msgid ""
msgstr ""
"POT-Creation-Date: 2026-07-16 00:00+0900\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: settingSearch.trim()
#: apps/app/src/controllers/settings.tsx:924
msgid "‘{0}’에 대한 검색 결과가 없어요."
msgstr "No results found for '{0}'."

#: apps/ui/src/views/InviteAcceptView.tsx:172
msgid "\"{teamName}\" 팀에 초대됐어요"
msgstr "You've been invited to “{teamName}”"

#: apps/app/src/controllers/search.tsx:60
msgid "“{trimmed}” 에 대한 검색 결과가 없습니다"
msgstr "No results for “{trimmed}”"

#: apps/ui/src/features/task-view/TaskViewForm.tsx:105
msgid "(선택 없음 = 전체)"
msgstr "(none = all)"

#: apps/app/src/controllers/settings/SupportModal.tsx:42
msgid "[기능 건의]"
msgstr "[Feature request]"

#: apps/app/src/controllers/settings/SupportModal.tsx:52
msgid "[문의]"
msgstr "[Question]"

#: apps/app/src/controllers/settings/SupportModal.tsx:47
msgid "[버그 제보]"
msgstr "[Bug report]"

#. placeholder {0}: formatReminderDate(dateInTz(preview.target, timezone))
#. placeholder {1}: formatReminderTime(customTime)
#: apps/ui/src/components/SnoozeReminderModal.tsx:201
msgid "{0} {1}(으)로 미루기"
msgstr "Snooze until {0} {1}"

#. placeholder {0}: formatReminderDate(dateInTz(startDate, timezone))
#. placeholder {1}: formatReminderTime(anchorTimeIsDerived ? fallbackTime : timeInTz(startDate, timezone))
#: apps/ui/src/components/ReminderDayComposer/index.tsx:235
msgid "{0} {1}부터"
msgstr "From {0} {1}"

#. placeholder {0}: item.name
#: apps/ui/src/components/AttachmentList.tsx:181
msgid "{0} 다운로드"
msgstr "Download {0}"

#. placeholder {0}: member.name
#: apps/ui/src/features/team/TeamMembersTable.tsx:87
msgid "{0} 메뉴"
msgstr "{0} menu"

#. placeholder {0}: item.name
#: apps/ui/src/components/AttachmentList.tsx:132
msgid "{0} 미리보기"
msgstr "Preview {0}"

#. placeholder {0}: formatTimeAgo(i18n.locale, value.createdAt)
#: apps/ui/src/views/OneTaskView.tsx:758
#: apps/ui/src/views/PublicTaskView.tsx:145
msgid "{0} 생성됨"
msgstr "Created {0}"

#. placeholder {0}: selected[0].name
#. placeholder {1}: selected.length - 1
#: apps/ui/src/views/OneTaskView.tsx:292
msgid "{0} 외 {1}명"
msgstr "{0} and {1} others"

#. placeholder {0}: item.name
#: apps/ui/src/components/AttachmentList.tsx:190
msgid "{0} 제거"
msgstr "Remove {0}"

#. placeholder {0}: invitation.email
#: apps/ui/src/features/team/TeamMembersTable.tsx:220
msgid "{0} 초대 취소"
msgstr "Cancel invitation for {0}"

#. placeholder {0}: slowRequestTestStatus.elapsedMs
#: apps/app/src/controllers/settings.tsx:590
msgid "{0}ms 만에 끝났어요 — 3초 시점에 워치독이 PostHog 로 보고했어요(프로덕션 빌드에서만 전송)."
msgstr "Finished in {0}ms — at the 3s mark the watchdog reported to PostHog (sent only in production builds)."

#. placeholder {0}: rateLimitTestStatus.limited
#. placeholder {1}: rateLimitTestStatus.total
#: apps/app/src/controllers/settings.tsx:554
msgid "{0}건이 제한(429)됐어요. (총 {1}건 — 토스트가 떴는지 확인하세요)"
msgstr "{0} request(s) were rate-limited (429). (out of {1} total — check whether a toast appeared)"

#. placeholder {0}: member.name
#: apps/ui/src/views/OneTaskView.tsx:742
msgid "{0}님을 담당자로 지정했어요"
msgstr "Assigned {0} as the assignee"

#. placeholder {0}: sessionItems.length
#: apps/app/src/controllers/settings.tsx:421
msgid "{0}대"
msgstr "{0} devices"

#. placeholder {0}: Math.round(minutes / 60)
#: apps/ui/src/components/SnoozeReminderModal.tsx:160
msgid "{0}시간 뒤"
msgstr "In {0} hours"

#: apps/ui/src/views/NotificationsView.tsx:67
msgid "{actor}님이 {target} 작업 담당에서 회원님을 제외했어요"
msgstr "{actor} removed you from the task {target}"

#: apps/ui/src/views/NotificationsView.tsx:65
msgid "{actor}님이 {target} 작업에 회원님을 배정했어요"
msgstr "{actor} assigned you to the task {target}"

#: apps/ui/src/views/NotificationsView.tsx:71
msgid "{actor}님이 {target} 팀에서 회원님의 역할을 변경했어요"
msgstr "{actor} changed your role in the {target} team"

#: apps/ui/src/views/NotificationsView.tsx:69
msgid "{actor}님이 회원님을 {target} 팀에 추가했어요"
msgstr "{actor} added you to the {target} team"

#: apps/ui/src/components/InstallPromptBanner.tsx:53
msgid "{appName} 앱으로 설치하기"
msgstr "Install the {appName} app"

#: apps/ui/src/features/channel/ChannelItemMenu.tsx:57
msgid "{channelName} 메뉴"
msgstr "{channelName} menu"

#: shared/features/reminder/utils.ts:130
msgid "{dateLabel} {timeLabel}"
msgstr "{dateLabel} {timeLabel}"

#: shared/features/reminder/utils.ts:127
msgid "{dateLabel} 종일"
msgstr "{dateLabel} all day"

#: apps/app/src/hooks/UseTimezoneNudge.ts:45
msgid "{detected} 로 바꾸기"
msgstr "Switch to {detected}"

#: apps/ui/src/components/ReminderDayComposer/HourDial.tsx:45
msgid "{displayHour}시"
msgstr "{displayHour} o'clock"

#: apps/ui/src/views/VerifyEmailView.tsx:77
msgid "{email} 로 6자리 코드를 보냈어요. 10분 안에 입력해 주세요."
msgstr "We sent a 6-digit code to {email}. Enter it within 10 minutes."

#: apps/ui/src/features/team/CancelInvitationDialog.tsx:34
msgid "{email}님의 초대를 취소할까요?"
msgstr "Cancel the invitation for {email}?"

#: apps/ui/src/features/team/FolderItemMenu.tsx:121
msgid "{folderName} 메뉴"
msgstr "{folderName} menu"

#: shared/features/reminder/utils.ts:200
msgid "{interval}년 {month}.{day}"
msgstr "Every {interval} years on {month}.{day}"

#: shared/features/reminder/utils.ts:194
msgid "{interval}년 반복"
msgstr "Every {interval} years"

#: shared/features/reminder/utils.ts:174
msgid "{interval}달 {days}일"
msgstr "Every {interval} months on {days}"

#: shared/features/reminder/utils.ts:188
msgid "{interval}달 {ordinal} {weekdayLabels}"
msgstr "Every {interval} months on {ordinal} {weekdayLabels}"

#: shared/features/reminder/utils.ts:180
msgid "{interval}달마다 {ordinal} 반복돼요 (요일을 선택하세요)"
msgstr "Repeats every {interval} months on {ordinal} (select a weekday)"

#: shared/features/reminder/utils.ts:171
msgid "{interval}달마다 반복돼요 (날짜를 선택하세요)"
msgstr "Repeats every {interval} months (select a date)"

#: shared/features/reminder/utils.ts:144
msgid "{interval}분 반복"
msgstr "Every {interval} minutes"

#: shared/features/reminder/utils.ts:147
msgid "{interval}시간 반복"
msgstr "Every {interval} hours"

#: shared/features/reminder/utils.ts:150
msgid "{interval}일 반복"
msgstr "Every {interval} days"

#: shared/features/reminder/utils.ts:163
msgid "{interval}주 {days}"
msgstr "Every {interval} weeks on {days}"

#: shared/features/reminder/utils.ts:157
msgid "{interval}주마다 반복돼요 (요일을 선택하세요)"
msgstr "Repeats every {interval} weeks (select a weekday)"

#: apps/ui/src/views/InviteAcceptView.tsx:176
msgid "{inviterEmail}님이 회원님을 초대했어요."
msgstr "{inviterEmail} invited you."

#: apps/ui/src/features/team/TeamMembersHeader.tsx:30
msgid "{memberCount}명"
msgstr "{memberCount} members"

#: apps/ui/src/features/team/RemoveMemberDialog.tsx:34
msgid "{memberName}님을 제거할까요?"
msgstr "Remove {memberName}?"

#: apps/ui/src/components/SnoozeReminderModal.tsx:159
msgid "{minutes}분 뒤"
msgstr "In {minutes} min"

#: shared/features/reminder/utils.ts:35
msgid "{month}월 {day}일"
msgstr "{month}/{day}"

#: apps/ui/src/features/team/ProfileMenu.tsx:48
msgid "{nickname} 메뉴"
msgstr "{nickname} menu"

#: apps/app/src/pages/rate-limited/Page.tsx:84
msgid "{remainingSec}초 후 자동으로 돌아갑니다"
msgstr "Returning automatically in {remainingSec}s"

#: apps/ui/src/components/TaskCreateComposer.tsx:309
msgid "{selectedAssigneeCount}명"
msgstr "{selectedAssigneeCount} people"

#: apps/ui/src/components/TaskCreateComposer.tsx:329
msgid "{selectedChannelCount}개"
msgstr "{selectedChannelCount}"

#: apps/ui/src/features/team/TeamItemMenu.tsx:65
msgid "{teamName} 메뉴"
msgstr "{teamName} menu"

#: apps/ui/src/features/channel/CreateChannelDialog.tsx:22
msgid "{teamName} 팀에 만들 채널 이름을 입력해주세요."
msgstr "Enter a name for the new channel in {teamName}."

#: apps/ui/src/features/team/TeamSettingsDialog.tsx:83
msgid "{teamName} 팀을 나가시겠어요?"
msgstr "Leave the team {teamName}?"

#: apps/ui/src/features/team/TeamSettingsDialog.tsx:81
msgid "{teamName} 팀을 삭제하시겠어요?"
msgstr "Delete the team {teamName}?"

#: apps/ui/src/components/ReminderDayComposer/YearlySection.tsx:59
msgid "{viewMonth}월"
msgstr "Month {viewMonth}"

#. placeholder {0}: month + 1
#: apps/ui/src/atom/Calendar.tsx:46
msgid "{year}년 {0}월"
msgstr "{0}/{year}"

#: apps/ui/src/features/channel/ChannelItemMenu.tsx:105
msgid "#{channelName} 채널을 삭제할까요?"
msgstr "Delete #{channelName}?"

#: apps/ui/src/components/ReminderDayComposer/IntervalStepper.tsx:90
msgid "<0>반복 간격</0>{stepper}<1>마다</1>"
msgstr "<0>Repeat every</0>{stepper}<1></1>"

#: apps/ui/src/components/ReminderDayComposer/HourRangePicker.tsx:81
msgid "<0>적용 시간</0>{fromButton}<1>부터</1>{toButton}<2>까지</2>"
msgstr "<0>Active hours</0><1>from</1>{fromButton}<2>to</2>{toButton}"

#: apps/ui/src/views/OnboardingView.tsx:128
msgid "<p>AI 가 다음 할 일까지 정리했어요</p>"
msgstr "<p>AI even laid out what's next</p>"

#: apps/app/src/controllers/settings.tsx:754
msgid "🍞 토스트 테스트"
msgstr "🍞 Test toast"

#: apps/app/src/controllers/settings.tsx:568
msgid "🐢 느린 요청 테스트"
msgstr "🐢 Slow request test"

#: apps/app/src/controllers/settings.tsx:608
msgid "🔍 정보 확인"
msgstr "🔍 View info"

#: apps/app/src/controllers/settings.tsx:497
msgid "🔔 푸시 테스트"
msgstr "🔔 Test push"

#: apps/app/src/controllers/settings.tsx:534
msgid "🚦 Rate limit 테스트"
msgstr "🚦 Rate limit test"

#: apps/ui/src/components/ReminderDayComposer/QuickTimePresets.tsx:12
msgid "10분 뒤"
msgstr "In 10 min"

#: apps/app/src/App.tsx:259
#: apps/app/src/lib/NativeNotifications.ts:37
msgid "10분 뒤 다시"
msgstr "Remind in 10 min"

#: apps/ui/src/views/PublicLinkDialog.tsx:290
#: apps/ui/src/views/PublicLinkDialog.tsx:353
msgid "1개월"
msgstr "1 month"

#: apps/ui/src/views/PublicLinkDialog.tsx:291
#: apps/ui/src/views/PublicLinkDialog.tsx:354
msgid "1년"
msgstr "1 year"

#: apps/ui/src/views/PublicLinkDialog.tsx:289
#: apps/ui/src/views/PublicLinkDialog.tsx:352
msgid "1주"
msgstr "1 week"

#: apps/ui/src/components/ReminderDayComposer/QuickTimePresets.tsx:13
msgid "30분 뒤"
msgstr "In 30 min"

#: apps/ui/src/components/ReminderDayComposer/QuickTimePresets.tsx:11
msgid "5분 뒤"
msgstr "In 5 min"

#: apps/app/src/controllers/settings/DeleteAccountModal.tsx:99
msgid "7일 이내에 다시 로그인하지 않으면 계정과 모든 데이터가 삭제됩니다."
msgstr "If you don't log in again within 7 days, your account and all data will be deleted."

#: apps/ui/src/components/TaskCreateComposer.tsx:1299
msgid "AI로 생성 중"
msgstr "Generating with AI"

#: apps/ui/src/components/ReminderModal/index.tsx:189
msgid "AI로 생성하기"
msgstr "Generate with AI"

#: apps/app/src/controllers/settings.tsx:455
msgid "crona 웹훅 호출이 정상 동작하는지 확인해요."
msgstr "Checks that the crona webhook call works correctly."

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:193
msgid "Google Calendar 등에 이 URL을 등록하면 이후 일정이 바뀔 때마다 자동으로 동기화돼요."
msgstr "Register this URL in Google Calendar or another app, and your schedule will sync automatically whenever it changes."

#: apps/ui/src/features/auth/socialProviders.tsx:28
msgid "Google로 계속하기"
msgstr "Continue with Google"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:179
msgid "ICS 파일 다운로드"
msgstr "Download ICS file"

#: apps/ui/src/views/OneTaskMenu.tsx:110
msgid "ID 복사"
msgstr "Copy ID"

#: apps/ui/src/views/OneTaskMenu.tsx:105
msgid "ID를 복사했어요"
msgstr "Copied ID"

#: apps/ui/src/components/SessionList.tsx:113
msgid "IP 알 수 없음"
msgstr "Unknown IP"

#: apps/ui/src/components/TaskCreateComposer.tsx:709
msgid "iPhone은 설정 > 일반 > 키보드에서 '받아쓰기'를 켜야 음성 입력이 돼요"
msgstr "On iPhone, turn on Dictation in Settings > General > Keyboard to use voice input"

#: apps/app/src/controllers/settings.tsx:305
msgid "PostHog Error tracking에 “{label}” 제목으로 올라가요. 제목이 곧 그룹핑 키라, 제목을 바꿔 누르면 매번 새 이슈예요."
msgstr "It goes to PostHog Error tracking titled “{label}”. The title is the grouping key, so a different title always creates a new issue."

#: apps/app/src/controllers/settings.tsx:237
msgid "PostHog Error tracking에서 “{label}”로 확인해 보세요. 세션 리플레이 녹화도 켰어요(프로젝트에서 리플레이가 켜져 있어야 링크돼요)."
msgstr "Look for “{label}” in PostHog Error tracking. Session replay recording is on too (it links only if replay is enabled in the project)."

#: apps/app/src/controllers/settings.tsx:283
msgid "PostHog Error tracking에서 “{label}”로 확인해 보세요(tail 워커 경유, 잠시 걸릴 수 있어요)."
msgstr "Look for “{label}” in PostHog Error tracking (via the tail worker; it may take a moment)."

#: apps/app/src/controllers/settings.tsx:528
msgid "Rate limit 테스트"
msgstr "Rate limit test"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:287
msgid "session.pushSubscription (서버 저장값)"
msgstr "session.pushSubscription (stored on server)"

#: apps/ui/src/views/OnboardingView.tsx:56
msgid "SNS"
msgstr "Social media"

#: apps/ui/src/views/OnboardingView.tsx:289
msgid "task 가 추가됐어요"
msgstr "Task added"

#: apps/ui/src/views/OnboardingView.tsx:272
msgid "task 는 이렇게 만들어요"
msgstr "Here's how to create a task"

#: apps/app/src/controllers/settings.tsx:263
msgid "unhandledrejection 으로 PostHog 가 자동 수집해요(프로덕션 빌드에서만 전송). Error tracking 에서 “{label}” 확인."
msgstr "PostHog auto-captures this via unhandledrejection (sent only in production builds). Check “{label}” under Error tracking."

#: apps/app/src/controllers/settings/DevInfoModal.tsx:210
msgid "userAgent (서버 기록)"
msgstr "userAgent (server record)"

#: apps/ui/src/components/TimezoneSelect.tsx:44
msgid "UTC"
msgstr "UTC"

#: apps/ui/src/features/task-view/TaskViewForm.tsx:194
#: apps/ui/src/features/task-view/TaskViewForm.tsx:195
msgid "View 이름"
msgstr "View name"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:254
msgid "Web Push 구독 정보"
msgstr "Web Push subscription"

#: apps/app/src/controllers/settings.tsx:251
msgid "window.onerror 로 나가 PostHog 가 자동 수집해요(프로덕션 빌드에서만 전송). Error tracking 에서 “{label}” 확인."
msgstr "This goes out via window.onerror and PostHog auto-captures it (sent only in production builds). Check “{label}” under Error tracking."

#: apps/app/src/pages/login/Page.tsx:135
#: apps/app/src/queries/Auth.ts:28
msgid "가입에 실패했습니다."
msgstr "Sign-up failed."

#: apps/ui/src/views/InviteAcceptView.tsx:114
#: apps/ui/src/views/LoginView.tsx:66
#: apps/ui/src/views/LoginView.tsx:386
msgid "가입하기"
msgstr "Sign up"

#: apps/ui/src/views/VerifyEmailView.tsx:79
msgid "가입한 이메일로 6자리 코드를 보냈어요. 10분 안에 입력해 주세요."
msgstr "We sent a 6-digit code to your email. Enter it within 10 minutes."

#: apps/ui/src/views/ForgotPasswordView.tsx:80
msgid "가입한 이메일을 입력하면 재설정 링크를 보내드려요."
msgstr "Enter your email and we'll send you a reset link."

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:222
msgid "가입한 팀이 없어요"
msgstr "You haven't joined any teams"

#: apps/ui/src/components/ReminderDayComposer/IntervalStepper.tsx:71
msgid "간격 늘리기"
msgstr "Increase interval"

#: apps/ui/src/components/ReminderDayComposer/IntervalStepper.tsx:41
msgid "간격 줄이기"
msgstr "Decrease interval"

#: apps/ui/src/features/task/TaskListView.tsx:35
msgid "간략"
msgstr "Brief"

#: apps/ui/src/views/OnboardingView.tsx:62
msgid "개발자"
msgstr "Developer"

#: apps/app/src/controllers/settings.tsx:487
msgid "개발자모드"
msgstr "Developer mode"

#: apps/ui/src/features/task-view/TaskViewForm.tsx:174
msgid "개인 (나만 보기)"
msgstr "Personal (only me)"

#: apps/app/src/controllers/settings.tsx:815
msgid "건의"
msgstr "Suggestion"

#: apps/ui/src/features/task/TaskListToolbarActions.tsx:87
#: apps/ui/src/features/task/TaskListToolbarActions.tsx:111
#: apps/ui/src/views/OnboardingView.tsx:54
msgid "검색"
msgstr "Search"

#: apps/ui/src/components/Dropdown.tsx:174
#: apps/ui/src/features/channel/ChannelPicker.tsx:69
#: apps/ui/src/features/team/AssigneePicker.tsx:77
#: apps/ui/src/features/team/TeamDropdown.tsx:122
msgid "검색 결과가 없어요."
msgstr "No results found."

#: apps/ui/src/components/Dropdown.tsx:75
msgid "검색…"
msgstr "Search…"

#: apps/app/src/controllers/settings.tsx:787
msgid "경고"
msgstr "Warning"

#: apps/app/src/controllers/settings.tsx:330
msgid "계정"
msgstr "Account"

#: apps/app/src/controllers/settings.tsx:815
msgid "계정 삭제"
msgstr "Delete account"

#: apps/app/src/queries/Account.ts:16
msgid "계정 삭제 요청에 실패했습니다."
msgstr "Failed to request account deletion."

#: apps/app/src/controllers/settings/DeleteAccountModal.tsx:89
#: apps/app/src/controllers/settings/SupportModal.tsx:62
msgid "계정 삭제하기"
msgstr "Delete account"

#: apps/app/src/controllers/settings/DeleteAccountModal.tsx:55
msgid "계정을 삭제할까요?"
msgstr "Delete your account?"

#: apps/ui/src/atom/TaskStatusIcon.tsx:53
msgid "계획됨"
msgstr "Planned"

#: apps/app/src/controllers/settings.tsx:811
#: apps/app/src/controllers/settings.tsx:815
#: apps/app/src/controllers/settings.tsx:827
#: apps/app/src/controllers/settings/SupportModal.tsx:33
msgid "고객센터"
msgstr "Support"

#: apps/ui/src/views/OneTaskMenu.tsx:125
#: apps/ui/src/views/PublicLinkDialog.tsx:239
msgid "공개 링크"
msgstr "Public link"

#: apps/ui/src/views/PublicLinkDialog.tsx:402
msgid "공개 링크 만들기"
msgstr "Create public link"

#: apps/ui/src/views/PublicLinkDialog.tsx:136
msgid "공개 링크를 만들었어요"
msgstr "Created a public link"

#: apps/ui/src/views/PublicLinkDialog.tsx:152
msgid "공개 링크를 해제했어요"
msgstr "Disabled the public link"

#: apps/ui/src/features/task-view/TaskViewForm.tsx:202
#: apps/ui/src/features/task-view/TaskViewForm.tsx:205
msgid "공개 범위"
msgstr "Visibility"

#: apps/app/src/pages/public-task/Page.tsx:56
msgid "공유 링크가 만료되었거나 더 이상 유효하지 않아요."
msgstr "This shared link has expired or is no longer valid."

#: apps/ui/src/features/team/TeamRoleBadge.tsx:20
msgid "관리자"
msgstr "Admin"

#: apps/ui/src/views/OnboardingView.tsx:57
msgid "광고"
msgstr "Ads"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:189
msgid "구독 링크"
msgstr "Subscription link"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:311
msgid "구독 링크 만들기"
msgstr "Create subscription link"

#: apps/app/src/controllers/settings.tsx:435
#: apps/app/src/controllers/settings/PermissionSection.tsx:50
msgid "권한"
msgstr "Permissions"

#: apps/app/src/controllers/settings.tsx:273
#: apps/app/src/controllers/settings.tsx:296
msgid "권한이 없어요 — 관리자만 발동할 수 있어요."
msgstr "You don't have permission — only admins can trigger this."

#: apps/app/src/controllers/settings/DeleteAccountModal.tsx:96
msgid "그동안 이용해 주셔서 감사했어요"
msgstr "Thank you for using our service"

#: apps/ui/src/features/task/TaskListView.tsx:134
#: apps/ui/src/features/task/TaskListView.tsx:136
msgid "그룹"
msgstr "Group"

#: apps/app/src/controllers/settings.tsx:823
msgid "기능 건의, 버그 제보, 계정 삭제를 여기서 할 수 있어요."
msgstr "Request features, report bugs, or delete your account here."

#: apps/app/src/controllers/settings/SupportModal.tsx:43
msgid "기능 건의하기"
msgstr "Request a feature"

#: apps/app/src/controllers/settings.tsx:766
#: apps/ui/src/components/ThemeSelect.tsx:20
msgid "기본"
msgstr "Default"

#: apps/app/src/controllers/settings.tsx:764
msgid "기본 토스트 메시지예요."
msgstr "This is a default toast message."

#: apps/ui/src/views/OnboardingView.tsx:58
#: apps/ui/src/views/OnboardingView.tsx:67
msgid "기타"
msgstr "Other"

#: apps/ui/src/views/OnboardingView.tsx:64
msgid "기획"
msgstr "Product manager"

#: apps/app/src/controllers/settings/PermissionSection.tsx:30
msgid "꺼짐"
msgstr "Off"

#: apps/app/src/hooks/PendingImageUploadGuard.tsx:67
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:109
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:155
msgid "나가기"
msgstr "Leave"

#: apps/ui/src/features/team/TeamSettingsDialog.tsx:90
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:151
msgid "나가면 이 팀의 작업과 정보에 더 이상 접근할 수 없어요."
msgstr "If you leave, you'll lose access to this team's tasks and data."

#: apps/ui/src/components/InstallPromptBanner.tsx:94
msgid "나중에"
msgstr "Later"

#: apps/ui/src/components/DatePickerModal.tsx:37
#: apps/ui/src/components/SnoozeReminderModal.tsx:180
msgid "날짜"
msgstr "Date"

#: apps/ui/src/atom/MonthlyDateGrid.tsx:116
msgid "날짜 선택"
msgstr "Select dates"

#: apps/ui/src/components/ReminderDayComposer/MonthlySection.tsx:15
msgid "날짜로"
msgstr "By date"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:138
msgid "내 전체"
msgstr "All"

#: apps/app/src/controllers/settings.tsx:330
#: apps/app/src/controllers/settings.tsx:346
#: apps/app/src/controllers/settings/ProfileModal.tsx:131
msgid "내 정보"
msgstr "My info"

#: apps/ui/src/features/task/TaskListFilter.tsx:130
msgid "내가 담당한 작업만"
msgstr "Only tasks assigned to me"

#: apps/app/src/controllers/task-view.tsx:53
#: apps/ui/src/features/task-view/TaskViewForm.tsx:170
#: apps/ui/src/features/task/TaskListSort.tsx:149
msgid "내림차순"
msgstr "Descending"

#: apps/app/src/controllers/calendar.tsx:108
msgid "내보내기"
msgstr "Export"

#: apps/ui/src/components/SnoozeReminderModal.tsx:169
msgid "내일 아침 9시"
msgstr "Tomorrow 9 AM"

#: apps/app/src/controllers/settings.tsx:167
#: apps/app/src/controllers/settings.tsx:224
#: apps/app/src/controllers/settings.tsx:287
#: apps/app/src/controllers/settings.tsx:309
msgid "네트워크 오류"
msgstr "Network error"

#: shared/features/reminder/labels.ts:16
msgid "넷째 주"
msgstr "4th week"

#: apps/ui/src/components/ReminderDayComposer/YearlySection.tsx:47
msgid "년"
msgstr "years"

#: apps/ui/src/components/TimezoneSelect.tsx:21
msgid "뉴델리"
msgstr "New Delhi"

#: apps/ui/src/components/TimezoneSelect.tsx:35
msgid "뉴욕 (동부)"
msgstr "New York (Eastern)"

#: apps/app/src/controllers/settings.tsx:562
msgid "느린 요청"
msgstr "Slow request"

#: apps/app/src/controllers/settings.tsx:584
msgid "느린 요청 보내기"
msgstr "Send slow request"

#: apps/app/src/controllers/settings.tsx:330
#: apps/ui/src/features/auth/NicknameField.tsx:25
msgid "닉네임"
msgstr "Nickname"

#: shared/dto/auth/messages.ts:14
msgid "닉네임을 입력해 주세요."
msgstr "Please enter a nickname."

#: apps/ui/src/views/InviteAcceptView.tsx:158
msgid "다른 계정으로 로그인"
msgstr "Sign in with a different account"

#: apps/ui/src/views/InviteAcceptView.tsx:148
msgid "다른 계정으로 로그인돼 있어요"
msgstr "You're signed in with a different account"

#: apps/ui/src/views/LoginView.tsx:315
msgid "다른 방법으로 로그인"
msgstr "More sign-in options"

#: apps/ui/src/features/auth/SessionManager.tsx:33
msgid "다른 세션 모두 해제"
msgstr "Sign out all other sessions"

#: apps/ui/src/features/auth/RevokeOtherSessionsDialog.tsx:31
msgid "다른 세션을 모두 해제할까요?"
msgstr "Sign out all other sessions?"

#: apps/app/src/queries/Session.ts:58
msgid "다른 세션을 해제하지 못했습니다."
msgstr "Failed to sign out other sessions."

#: apps/ui/src/views/VerifyEmailView.tsx:124
msgid "다시 보냈어요"
msgstr "Resent"

#: apps/app/src/components/TaskView.tsx:565
#: apps/app/src/pages/desktop-handoff/Page.tsx:32
#: apps/ui/src/components/AttachmentUploadDialog.tsx:170
msgid "다시 시도"
msgstr "Try again"

#: apps/ui/src/features/team/LogoutConfirmDialog.tsx:30
msgid "다시 이용하려면 로그인이 필요해요."
msgstr "You'll need to sign in again to continue."

#: apps/app/src/controllers/settings.tsx:757
msgid "다양한 상황의 토스트를 띄워볼 수 있어요."
msgstr "Try out toasts for various situations."

#: apps/ui/src/components/DownloadTray.tsx:86
msgid "다운로드 실패"
msgstr "Download failed"

#: apps/ui/src/components/DownloadTray.tsx:88
msgid "다운로드 완료"
msgstr "Download complete"

#: apps/ui/src/components/DownloadTray.tsx:89
msgid "다운로드 중…"
msgstr "Downloading…"

#: apps/ui/src/views/OnboardingView.tsx:193
#: apps/ui/src/views/OnboardingView.tsx:219
#: apps/ui/src/views/OnboardingView.tsx:256
#: apps/ui/src/views/OnboardingView.tsx:292
msgid "다음"
msgstr "Next"

#: apps/ui/src/atom/Calendar.tsx:52
#: apps/ui/src/components/ReminderDayComposer/YearlySection.tsx:63
msgid "다음 달"
msgstr "Next month"

#: apps/ui/src/views/OneTaskView.tsx:952
msgid "다음 알림 시각을 불러오지 못했어요."
msgstr "Couldn't load the next reminder time."

#: apps/ui/src/components/SnoozeReminderModal.tsx:140
msgid "다음 알림 한 번만 미뤄요. 반복 규칙은 그대로예요."
msgstr "Snoozes only the next reminder. The repeat rule stays as is."

#. placeholder {0}: formatReminderDate(dateInTz(nextRunAt, viewerTimezone))
#. placeholder {1}: formatReminderTime(timeInTz(nextRunAt, viewerTimezone))
#: apps/ui/src/views/OneTaskView.tsx:956
msgid "다음 알림: {0} {1}"
msgstr "Next reminder: {0} {1}"

#. placeholder {0}: formatReminderDate(dateInTz(next, timezone))
#. placeholder {1}: formatReminderTime(timeInTz(next, timezone))
#: apps/app/src/lib/SnoozeToast.ts:23
msgid "다음 알림: {0} {1}(으)로 미뤄졌어요"
msgstr "Reminder pushed to {0} {1}"

#: apps/ui/src/views/OneTaskView.tsx:950
msgid "다음 알림을 확인하고 있어요…"
msgstr "Checking the next reminder…"

#: apps/ui/src/components/DeferReminderDialog.tsx:54
msgid "다음 회차로 미루기"
msgstr "Defer to next occurrence"

#: apps/app/src/controllers/settings.tsx:380
#: apps/ui/src/components/ThemeSelect.tsx:15
msgid "다크"
msgstr "Dark"

#: apps/app/src/components/MasterDetail.tsx:58
#: apps/ui/src/components/DownloadTray.tsx:95
#: apps/ui/src/components/InstallPromptBanner.tsx:70
#: apps/ui/src/components/Toast.tsx:379
#: apps/ui/src/features/team/CancelInvitationDialog.tsx:46
msgid "닫기"
msgstr "Close"

#: apps/ui/src/components/ReminderDayComposer/MonthlySection.tsx:37
msgid "달"
msgstr "months"

#: apps/ui/src/components/TaskCreateComposer.tsx:304
#: apps/ui/src/features/task-view/TaskViewForm.tsx:241
#: apps/ui/src/features/task/TaskListFilter.tsx:114
#: apps/ui/src/features/team/AssigneeDropdown.tsx:84
#: apps/ui/src/views/OneTaskView.tsx:257
msgid "담당자"
msgstr "Assignee"

#: apps/ui/src/features/team/AssigneeDropdown.tsx:92
msgid "담당자 {count}명"
msgstr "{count} assignees"

#: apps/ui/src/features/team/AssigneePicker.tsx:57
msgid "담당자 검색"
msgstr "Search assignees"

#: apps/ui/src/features/team/AssigneePicker.tsx:63
msgid "담당자 검색…"
msgstr "Search assignees…"

#: apps/ui/src/features/team/AssigneeDropdown.tsx:104
msgid "담당자 선택"
msgstr "Select assignee"

#: apps/ui/src/components/TaskCreateComposer.tsx:403
msgid "담당자 설정"
msgstr "Set assignee"

#: apps/ui/src/views/OneTaskView.tsx:269
#: apps/ui/src/views/OneTaskView.tsx:749
msgid "담당자 없음"
msgstr "No assignee"

#: apps/ui/src/features/team/AssigneeDropdown.tsx:98
msgid "담당자 추가"
msgstr "Add assignee"

#. placeholder {0}: assignee.name
#: apps/ui/src/components/TaskRow.tsx:229
#: apps/ui/src/features/task/TaskBoard.tsx:614
msgid "담당자: {0}"
msgstr "Assignee: {0}"

#: apps/app/src/controllers/one-task.tsx:227
#: apps/app/src/controllers/task-list.tsx:16
msgid "대시보드"
msgstr "Dashboard"

#: apps/app/src/controllers/one-task.tsx:135
msgid "대시보드로 돌아가기"
msgstr "Back to dashboard"

#: apps/ui/src/features/task/TaskBoard.tsx:458
#: apps/ui/src/features/task/TaskList.tsx:464
msgid "더 보기"
msgstr "Show more"

#: apps/ui/src/components/AttachmentList.tsx:217
msgid "더 보기 ({hiddenCount})"
msgstr "Show more ({hiddenCount})"

#: apps/app/src/controllers/settings.tsx:795
msgid "더 자세한 정보를 여기에 담을 수 있어요."
msgstr "You can add more details here."

#: apps/ui/src/features/task/TaskListToolbarActions.tsx:55
msgid "더보기"
msgstr "More"

#: apps/ui/src/components/TimezoneSelect.tsx:37
msgid "덴버 (산악)"
msgstr "Denver (Mountain)"

#: apps/ui/src/components/ScheduleComposer.tsx:231
#: apps/ui/src/components/ScheduleComposer.tsx:270
msgid "도움말"
msgstr "Help"

#: apps/ui/src/components/TimezoneSelect.tsx:12
msgid "도쿄 (JST)"
msgstr "Tokyo (JST)"

#: apps/app/src/layouts/dashboard/Service.ts:383
msgid "되돌리기"
msgstr "Undo"

#: apps/app/src/controllers/search.tsx:66
msgid "두 글자 이상 입력해 주세요"
msgstr "Type at least two characters"

#: apps/ui/src/components/ReminderDayComposer/QuickTimePresets.tsx:15
msgid "두 시간 뒤"
msgstr "In 2 hr"

#: apps/ui/src/components/TimezoneSelect.tsx:22
msgid "두바이"
msgstr "Dubai"

#: shared/features/reminder/labels.ts:14
msgid "둘째 주"
msgstr "2nd week"

#: apps/ui/src/components/AvatarCropModal.tsx:89
msgid "드래그와 확대/축소로 원 안에 담을 영역을 맞춰주세요."
msgstr "Drag and zoom to fit the area inside the circle."

#: apps/ui/src/components/ReminderList.tsx:123
msgid "등록된 알림이 없어요."
msgstr "No reminders yet."

#: apps/app/src/controllers/settings/DevInfoModal.tsx:191
msgid "디버그 정보"
msgstr "Debug info"

#: apps/ui/src/views/OnboardingView.tsx:63
msgid "디자이너"
msgstr "Designer"

#: apps/ui/src/views/LoginView.tsx:325
msgid "또는"
msgstr "or"

#: apps/app/src/controllers/settings.tsx:715
msgid "라벨이 그대로 PostHog 이슈 제목이 돼요 — 제목이 다르면 새 이슈예요."
msgstr "The label becomes the PostHog issue title as-is — a different title means a new issue."

#: apps/app/src/controllers/settings.tsx:380
#: apps/ui/src/components/ThemeSelect.tsx:14
msgid "라이트"
msgstr "Light"

#: apps/ui/src/components/TimezoneSelect.tsx:26
msgid "런던"
msgstr "London"

#: apps/app/src/controllers/settings.tsx:652
#: apps/app/src/controllers/settings.tsx:699
msgid "렌더 크래시"
msgstr "Render crash"

#: apps/app/src/controllers/settings.tsx:839
#: apps/app/src/controllers/settings.tsx:846
#: apps/ui/src/features/team/LogoutConfirmDialog.tsx:49
#: apps/ui/src/features/team/ProfileMenu.tsx:79
msgid "로그아웃"
msgstr "Sign out"

#: apps/ui/src/features/team/LogoutConfirmDialog.tsx:27
msgid "로그아웃 하시겠어요?"
msgstr "Sign out?"

#: apps/app/src/pages/login/Page.tsx:39
#: apps/ui/src/views/InviteAcceptView.tsx:111
#: apps/ui/src/views/LoginView.tsx:64
#: apps/ui/src/views/LoginView.tsx:64
msgid "로그인"
msgstr "Sign in"

#: apps/ui/src/views/PublicLinkDialog.tsx:242
msgid "로그인 없이도 이 링크로 작업을 볼 수 있어요. 유효기간은 최대 1년이에요."
msgstr "Anyone with this link can view the task without signing in. It stays valid for up to 1 year."

#: apps/app/src/pages/desktop-handoff/Page.tsx:18
msgid "로그인 연결에 실패했어요."
msgstr "Failed to connect sign-in."

#: apps/app/src/controllers/settings.tsx:404
#: apps/app/src/controllers/settings.tsx:412
#: apps/app/src/controllers/settings/SessionsModal.tsx:36
msgid "로그인된 기기"
msgstr "Signed-in devices"

#: apps/app/src/pages/login/Page.tsx:88
#: apps/app/src/pages/login/Page.tsx:112
#: apps/app/src/pages/login/Page.tsx:117
msgid "로그인에 실패했습니다."
msgstr "Sign-in failed."

#: apps/ui/src/views/ForgotPasswordView.tsx:72
#: apps/ui/src/views/ForgotPasswordView.tsx:103
#: apps/ui/src/views/LoginView.tsx:386
#: apps/ui/src/views/ResetPasswordView.tsx:74
msgid "로그인으로 돌아가기"
msgstr "Back to sign in"

#: apps/ui/src/views/ResetPasswordView.tsx:85
msgid "로그인하기"
msgstr "Log in"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:243
msgid "로드됨"
msgstr "Loaded"

#: apps/ui/src/components/TimezoneSelect.tsx:30
msgid "로마"
msgstr "Rome"

#: apps/ui/src/components/TimezoneSelect.tsx:38
msgid "로스앤젤레스 (태평양)"
msgstr "Los Angeles (Pacific)"

#: apps/ui/src/components/ThemeSelect.tsx:25
msgid "로즈"
msgstr "Rose"

#: apps/ui/src/atom/TaskStatusIcon.tsx:59
msgctxt "task status"
msgid "루틴"
msgstr "Routine"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:271
#: apps/ui/src/views/PublicLinkDialog.tsx:258
msgid "링크 복사"
msgstr "Copy link"

#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:353
#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:354
msgid "링크 열기"
msgstr "Open link"

#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:384
#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:385
msgid "링크 제거"
msgstr "Remove link"

#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:180
#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:343
msgid "링크 주소"
msgstr "Link URL"

#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:148
msgid "링크 추가"
msgstr "Add link"

#: apps/ui/src/views/PublicLinkDialog.tsx:230
#: apps/ui/src/views/PublicLinkDialog.tsx:328
msgid "링크 해제"
msgstr "Disable link"

#: apps/ui/src/views/InviteAcceptView.tsx:133
msgid "링크가 만료됐거나, 취소됐거나, 이미 처리된 초대예요."
msgstr "This invitation has expired, been canceled, or was already handled."

#: apps/ui/src/views/ResetPasswordView.tsx:70
msgid "링크가 유효하지 않거나 만료되었어요. 다시 요청해 주세요."
msgstr "This link is invalid or has expired. Please request a new one."

#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:221
msgid "링크로 이미지 추가"
msgstr "Add image by URL"

#: apps/ui/src/views/PublicLinkDialog.tsx:130
msgid "링크를 만들어 클립보드에 복사했어요"
msgstr "Created a link and copied it to the clipboard"

#: apps/app/src/pages/public-task/Page.tsx:53
msgid "링크를 열 수 없어요"
msgstr "Couldn't open the link"

#: apps/ui/src/views/PublicLinkDialog.tsx:195
msgid "링크를 해제할까요?"
msgstr "Disable this link?"

#: apps/ui/src/components/TimezoneSelect.tsx:19
msgid "마닐라"
msgstr "Manila"

#: apps/ui/src/components/TimezoneSelect.tsx:29
msgid "마드리드"
msgstr "Madrid"

#: apps/ui/src/components/AttachmentUploadDialog.tsx:242
msgid "마무리하는 중…"
msgstr "Finishing…"

#: apps/ui/src/components/TaskCreateComposer.tsx:702
msgid "마이크 사용 권한이 필요해요"
msgstr "Microphone access is required"

#: shared/features/reminder/labels.ts:17
msgid "마지막 주"
msgstr "Last week"

#: apps/ui/src/views/OnboardingView.tsx:65
msgid "마케팅"
msgstr "Marketer"

#: apps/ui/src/features/channel/CreateChannelDialog.tsx:27
#: apps/ui/src/features/team/CreateFolderDialog.tsx:70
#: apps/ui/src/features/team/CreateTeamDialog.tsx:118
msgid "만들기"
msgstr "Create"

#. placeholder {0}: formatDate(customExpiry(customDate))
#. placeholder {0}: formatDate(link.expiresAt)
#. placeholder {0}: formatDate(presetExpiry(presetDays))
#: apps/ui/src/views/PublicLinkDialog.tsx:270
#: apps/ui/src/views/PublicLinkDialog.tsx:379
#: apps/ui/src/views/PublicLinkDialog.tsx:386
msgid "만료: {0}"
msgstr "Expires: {0}"

#: shared/dto/auth/messages.ts:42
msgid "만료된 초대예요. 초대한 사람에게 다시 요청하세요."
msgstr "This invitation has expired. Please ask the inviter to send a new one."

#: apps/ui/src/views/PublicLinkDialog.tsx:389
msgid "만료일을 선택하세요 (최대 1년)"
msgstr "Choose an expiration date (up to 1 year)"

#: apps/ui/src/components/ReminderDayComposer/FrequencyDropdown.tsx:10
#: apps/ui/src/components/ReminderList.tsx:38
msgid "매 분"
msgstr "Every minute"

#: apps/ui/src/components/ReminderDayComposer/FrequencyDropdown.tsx:11
#: apps/ui/src/components/ReminderList.tsx:39
msgid "매 시간"
msgstr "Every hour"

#: apps/ui/src/components/ReminderDayComposer/FrequencyDropdown.tsx:15
#: apps/ui/src/components/ReminderList.tsx:43
#: shared/features/reminder/utils.ts:194
msgid "매년"
msgstr "Every year"

#: shared/features/reminder/utils.ts:199
msgid "매년 {month}.{day}"
msgstr "Every year on {month}.{day}"

#: shared/features/reminder/utils.ts:174
msgid "매달 {days}일"
msgstr "Monthly on {days}"

#: shared/features/reminder/utils.ts:187
msgid "매달 {ordinal} {weekdayLabels}"
msgstr "Monthly on {ordinal} {weekdayLabels}"

#: shared/features/reminder/utils.ts:179
msgid "매달 {ordinal} 반복돼요 (요일을 선택하세요)"
msgstr "Repeats monthly on {ordinal} (select a weekday)"

#: shared/features/reminder/utils.ts:170
msgid "매달 반복돼요 (날짜를 선택하세요)"
msgstr "Repeats monthly (select a date)"

#: shared/features/reminder/utils.ts:147
msgid "매시간"
msgstr "Hourly"

#: apps/ui/src/components/ReminderDayComposer/FrequencyDropdown.tsx:14
#: apps/ui/src/components/ReminderList.tsx:42
msgid "매월"
msgstr "Monthly"

#: apps/ui/src/components/ReminderDayComposer/MonthlySection.tsx:41
msgid "매월 반복 방식"
msgstr "Monthly repeat mode"

#: apps/ui/src/components/ReminderDayComposer/FrequencyDropdown.tsx:12
#: apps/ui/src/components/ReminderList.tsx:40
#: shared/features/reminder/utils.ts:150
msgid "매일"
msgstr "Daily"

#: apps/ui/src/components/ReminderDayComposer/FrequencyDropdown.tsx:13
#: apps/ui/src/components/ReminderList.tsx:41
msgid "매주"
msgstr "Weekly"

#: shared/features/reminder/utils.ts:163
msgid "매주 {days}"
msgstr "Weekly on {days}"

#: shared/features/reminder/utils.ts:156
msgid "매주 반복돼요 (요일을 선택하세요)"
msgstr "Repeats weekly (select a weekday)"

#: apps/app/src/hooks/PendingImageUploadGuard.tsx:60
msgid "머무르기"
msgstr "Stay"

#: apps/ui/src/components/TaskCreateComposer.tsx:236
#: apps/ui/src/components/TaskCreateComposer.tsx:244
msgid "메뉴"
msgstr "Menu"

#: apps/ui/src/components/TaskCreateComposer.tsx:1077
msgid "메모"
msgstr "Note"

#: apps/ui/src/components/TaskCreateComposer.tsx:1079
#: apps/ui/src/components/TaskCreateComposer.tsx:1110
msgid "메모 추가"
msgstr "Add a note"

#: apps/ui/src/features/team/TeamRoleBadge.tsx:21
msgid "메인테이너"
msgstr "Maintainer"

#: apps/ui/src/components/TimezoneSelect.tsx:41
msgid "멕시코시티"
msgstr "Mexico City"

#: apps/ui/src/features/team/TeamRoleBadge.tsx:22
msgid "멤버"
msgstr "Member"

#: apps/ui/src/components/ReminderDayComposer/OrdinalDropdown.tsx:20
msgid "몇 번째 주"
msgstr "Week of month"

#: apps/app/src/controllers/notifications.tsx:85
msgid "모두 읽음"
msgstr "Mark all as read"

#: apps/ui/src/features/auth/RevokeOtherSessionsDialog.tsx:56
msgid "모두 해제"
msgstr "Sign out all"

#: apps/app/src/controllers/settings.tsx:380
#: apps/app/src/controllers/settings.tsx:384
#: apps/ui/src/components/ThemeSelect.tsx:65
msgid "모드"
msgstr "Appearance"

#: apps/ui/src/components/AttachmentUploadDialog.tsx:140
msgid "모든 형식의 파일을 여러 개 올릴 수 있어요."
msgstr "Upload any number of files, in any format."

#: apps/ui/src/components/TimezoneSelect.tsx:31
msgid "모스크바"
msgstr "Moscow"

#: apps/ui/src/features/task/TaskListView.tsx:34
msgid "목록"
msgstr "List"

#: apps/app/src/components/TaskView.tsx:563
msgid "목록을 불러오지 못했어요."
msgstr "Failed to load the list."

#: apps/app/src/controllers/settings/SupportModal.tsx:36
msgid "무엇을 도와드릴까요?"
msgstr "How can we help?"

#: apps/ui/src/components/TaskCreateComposer.tsx:1030
msgid "무엇을 해야 하나요?"
msgstr "What should we remind you about?"

#: apps/app/src/controllers/settings.tsx:815
#: apps/app/src/controllers/settings.tsx:820
msgid "문의하기"
msgstr "Contact us"

#: apps/app/src/queries/ReminderNlp.ts:50
msgid "문장을 해석하지 못했어요."
msgstr "Couldn't interpret the sentence."

#: apps/app/src/components/ErrorFallback.tsx:29
msgid "문제가 생겨 화면을 표시할 수 없어요"
msgstr "Something went wrong and this screen can't be shown"

#: apps/app/src/controllers/settings/SupportModal.tsx:53
msgid "물어보기"
msgstr "Ask a question"

#: apps/ui/src/components/ThemeSelect.tsx:22
msgid "미드나이트"
msgstr "Midnight"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:243
msgid "미로드"
msgstr "Not loaded"

#: apps/ui/src/components/SnoozeReminderModal.tsx:130
msgid "미루기"
msgstr "Snooze"

#: apps/ui/src/components/SnoozeReminderModal.tsx:128
msgid "미룰 알림이 없어요"
msgstr "No reminder to snooze"

#: apps/app/src/controllers/settings.tsx:691
msgid "미처리 거부"
msgstr "Unhandled rejection"

#: apps/app/src/controllers/settings.tsx:262
msgid "미처리 거부를 던졌어요"
msgstr "Threw an unhandled rejection"

#: apps/ui/src/components/ReminderDayComposer/RepeatModeToggle.tsx:13
msgid "반복"
msgstr "Repeat"

#: apps/ui/src/components/ReminderDayComposer/IntervalStepper.tsx:53
msgid "반복 간격 값"
msgstr "Repeat interval value"

#: apps/ui/src/components/ReminderDayComposer/FrequencyDropdown.tsx:28
msgid "반복 빈도"
msgstr "Repeat frequency"

#: shared/features/reminder/utils.ts:139
msgid "반복 안 함"
msgstr "No repeat"

#: apps/ui/src/components/CompleteRepeatReminderDialog.tsx:32
msgid "반복 알림을 삭제할까요?"
msgstr "Delete this recurring reminder?"

#: apps/ui/src/components/DeferReminderDialog.tsx:36
msgid "반복 알림을 어떻게 할까요?"
msgstr "What about the repeating reminder?"

#: apps/ui/src/views/OnboardingView.tsx:127
msgid "발표자료 준비 · 리허설 · 배포"
msgstr "Prep slides · Rehearse · Present"

#: apps/ui/src/components/TimezoneSelect.tsx:17
msgid "방콕"
msgstr "Bangkok"

#: apps/ui/src/features/task/TaskListSort.tsx:143
#: apps/ui/src/features/task/TaskListSort.tsx:145
msgid "방향"
msgstr "Direction"

#: apps/ui/src/views/NotificationsView.tsx:48
msgid "배정"
msgstr "Assign"

#: apps/ui/src/views/NotificationsView.tsx:49
msgid "배정 해제"
msgstr "Unassign"

#: apps/app/src/controllers/settings.tsx:815
msgid "버그"
msgstr "Bug"

#: apps/app/src/controllers/settings/SupportModal.tsx:48
msgid "버그 건의하기"
msgstr "Report a bug"

#: apps/app/src/controllers/settings.tsx:930
msgid "버전 {__APP_VERSION__}"
msgstr "Version {__APP_VERSION__}"

#: apps/ui/src/components/TimezoneSelect.tsx:28
msgid "베를린"
msgstr "Berlin"

#: apps/ui/src/components/TaskRow.tsx:321
#: apps/ui/src/views/OneTaskMenu.tsx:187
msgid "보관"
msgstr "Archive"

#: apps/ui/src/views/OneTaskView.tsx:665
msgid "보관된 작업이에요. 목록에는 표시되지 않아요."
msgstr "This task is archived. It won't appear in your lists."

#: apps/app/src/controllers/archive.tsx:18
msgid "보관된 할일이 없어요."
msgstr "No archived tasks."

#: apps/ui/src/views/OneTaskMenu.tsx:139
msgid "보관하기"
msgstr "Archive"

#: apps/ui/src/views/OneTaskMenu.tsx:165
msgid "보관하면 목록에서 숨겨지고, 이 작업과 하위 작업의 알림이 사라져요(다시 켤 수 없어요). 90일이 지나면 완전히 삭제돼요."
msgstr "Archiving hides it from the list and removes reminders for this task and its subtasks (this can't be turned back on). It's permanently deleted after 90 days."

#: apps/app/src/controllers/archive.tsx:13
#: apps/ui/src/features/task/TaskListToolbarActions.tsx:99
#: apps/ui/src/features/task/TaskListToolbarActions.tsx:119
msgid "보관함"
msgstr "Archive"

#: apps/app/src/components/TaskView.tsx:202
#: apps/app/src/controllers/one-task.tsx:207
msgid "보관함으로 옮겼어요"
msgstr "Moved to archive"

#: apps/ui/src/features/task/TaskListView.tsx:79
#: apps/ui/src/features/task/TaskListView.tsx:87
#: apps/ui/src/features/task/TaskListView.tsx:93
msgid "보기"
msgstr "View"

#: apps/ui/src/features/task/TaskListView.tsx:100
#: apps/ui/src/features/task/TaskListView.tsx:102
msgid "보기 방식"
msgstr "Layout"

#: apps/ui/src/features/task/TaskListView.tsx:36
msgid "보드"
msgstr "Board"

#: apps/ui/src/views/OneTaskView.tsx:675
msgid "복구"
msgstr "Restore"

#: apps/ui/src/components/editor/LinkRichCard.tsx:74
#: apps/ui/src/components/Toast.tsx:370
msgid "복사"
msgstr "Copy"

#: apps/ui/src/components/Toast.tsx:370
msgid "복사됨"
msgstr "Copied"

#: apps/ui/src/components/ReminderDayComposer/MinuteSection.tsx:30
msgid "분"
msgstr "minutes"

#: apps/ui/src/components/ClockTimePicker.tsx:116
msgid "분 선택"
msgstr "Select minutes"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:263
msgid "불러오는 중..."
msgstr "Loading..."

#: apps/app/src/controllers/task-view.tsx:95
#: apps/ui/src/features/task/TaskBoard.tsx:458
#: apps/ui/src/features/task/TaskList.tsx:464
#: apps/ui/src/views/PublicLinkDialog.tsx:248
msgid "불러오는 중…"
msgstr "Loading…"

#: apps/app/src/pages/login/Page.tsx:45
msgid "브라우저에서 로그인"
msgstr "Sign in with browser"

#: apps/app/src/pages/login/Page.tsx:42
msgid "브라우저에서 로그인을 마치면 자동으로 돌아와요."
msgstr "You'll return automatically after signing in with your browser."

#: apps/ui/src/features/auth/PasswordField.tsx:45
msgid "비밀번호"
msgstr "Password"

#: apps/ui/src/views/ResetPasswordView.tsx:128
msgid "비밀번호 변경"
msgstr "Change password"

#: apps/app/src/pages/reset-password/Page.tsx:33
msgid "비밀번호 변경에 실패했습니다."
msgstr "Failed to change password."

#: apps/ui/src/views/ResetPasswordView.tsx:64
msgid "비밀번호 재설정"
msgstr "Reset password"

#: apps/ui/src/views/ForgotPasswordView.tsx:62
msgid "비밀번호 찾기"
msgstr "Forgot password"

#: apps/ui/src/features/auth/PasswordConfirmField.tsx:27
msgid "비밀번호 확인"
msgstr "Confirm password"

#: shared/dto/auth/messages.ts:17
msgid "비밀번호가 일치하지 않습니다."
msgstr "Passwords do not match."

#: shared/dto/auth/messages.ts:16
msgid "비밀번호는 8자 이상이어야 합니다."
msgstr "Password must be at least 8 characters."

#: apps/ui/src/views/ResetPasswordView.tsx:81
msgid "비밀번호를 바꿨어요. 새 비밀번호로 로그인해 주세요."
msgstr "Your password has been changed. Log in with your new password."

#: shared/dto/auth/messages.ts:15
msgid "비밀번호를 입력해 주세요."
msgstr "Please enter your password."

#: apps/ui/src/views/LoginView.tsx:373
msgid "비밀번호를 잊으셨나요?"
msgstr "Forgot your password?"

#: apps/ui/src/components/AvatarCropModal.tsx:86
msgid "사진 편집"
msgstr "Edit photo"

#: apps/app/src/controllers/task-view.tsx:138
#: apps/ui/src/components/TaskRow.tsx:272
#: apps/ui/src/features/channel/ChannelItemMenu.tsx:127
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:109
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:170
msgid "삭제"
msgstr "Delete"

#: apps/app/src/controllers/one-task.tsx:128
msgid "삭제되었거나 존재하지 않는 작업이에요."
msgstr "This task was deleted or doesn't exist."

#: apps/ui/src/components/CompleteRepeatReminderDialog.tsx:54
msgid "삭제하고 완료"
msgstr "Delete and complete"

#: apps/ui/src/features/channel/ChannelItemMenu.tsx:108
msgid "삭제하면 채널과 연결된 작업 목록에 더 이상 접근할 수 없어요."
msgstr "Deleting it means you'll no longer be able to access the task list linked to this channel."

#: apps/ui/src/features/team/TeamSettingsDialog.tsx:88
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:166
msgid "삭제하면 팀이 보관 처리되고, 90일이 지나면 모든 데이터가 영구적으로 삭제돼요."
msgstr "Deleting archives the team; after 90 days, all of its data is permanently deleted."

#: apps/ui/src/components/TaskCreateComposer.tsx:265
#: apps/ui/src/components/TaskCreateComposer.tsx:354
#: apps/ui/src/components/TaskCreateComposer.tsx:358
#: apps/ui/src/components/TaskStatusDropdown.tsx:111
#: apps/ui/src/components/TaskStatusDropdown.tsx:157
#: apps/ui/src/features/task-view/TaskViewForm.tsx:232
#: apps/ui/src/features/task/TaskListFilter.tsx:139
#: apps/ui/src/features/task/TaskListFilter.tsx:141
msgid "상태"
msgstr "Status"

#: apps/ui/src/components/TaskStatusDropdown.tsx:131
#: apps/ui/src/components/TaskStatusDropdown.tsx:216
msgid "상태 변경"
msgstr "Change status"

#. placeholder {0}: withRo(i18n._(TASK_STATUS_LABELS[next]))
#: apps/app/src/queries/all-tasks.ts:494
msgid "상태를 {0} 바꿨어요"
msgstr "Changed status to {0}"

#: apps/ui/src/features/task/TaskListView.tsx:140
msgid "상태별"
msgstr "By status"

#: apps/ui/src/components/TimezoneSelect.tsx:40
msgid "상파울루"
msgstr "São Paulo"

#: apps/ui/src/components/TimezoneSelect.tsx:13
msgid "상하이 (CST)"
msgstr "Shanghai (CST)"

#: apps/ui/src/views/NotificationsView.tsx:73
msgid "새 기기 {target}에서 로그인했어요"
msgstr "New sign-in from {target}"

#: apps/ui/src/views/NotificationsView.tsx:52
msgid "새 로그인"
msgstr "New sign-in"

#: apps/ui/src/views/PublicLinkDialog.tsx:221
#: apps/ui/src/views/PublicLinkDialog.tsx:320
msgid "새 링크 만들기"
msgstr "Create new link"

#: apps/ui/src/views/PublicLinkDialog.tsx:193
msgid "새 링크를 만들까요?"
msgstr "Create a new link?"

#: apps/ui/src/views/PublicLinkDialog.tsx:200
msgid "새 링크를 만들면 지금 링크는 더 이상 열리지 않아요."
msgstr "Creating a new link will stop the current one from working."

#: apps/ui/src/views/ResetPasswordView.tsx:102
msgid "새 비밀번호"
msgstr "New password"

#: apps/ui/src/components/TeamNav/TeamNav.tsx:576
#: apps/ui/src/features/channel/CreateChannelDialog.tsx:19
msgid "새 채널 만들기"
msgstr "Create new channel"

#: apps/ui/src/features/team/CreateTeamDialog.tsx:63
#: apps/ui/src/features/team/TeamMenu.tsx:71
msgid "새 팀 만들기"
msgstr "Create new team"

#: apps/ui/src/features/team/CreateFolderDialog.tsx:47
#: apps/ui/src/features/team/TeamMenu.tsx:84
msgid "새 폴더 추가"
msgstr "Add new folder"

#: apps/ui/src/features/onboarding/ThemePreview.tsx:62
msgid "새 할 일"
msgstr "New task"

#: apps/app/src/components/ErrorFallback.tsx:37
msgid "새로고침"
msgstr "Refresh"

#: apps/app/src/components/ErrorFallback.tsx:32
msgid "새로고침하면 대부분 해결돼요. 계속 문제가 있으면 잠시 후 다시 시도해 주세요."
msgstr "Refreshing usually fixes it. If the problem persists, please try again in a moment."

#: apps/app/src/controllers/settings.tsx:392
#: apps/ui/src/views/OnboardingView.tsx:213
msgid "색상"
msgstr "Color"

#: apps/ui/src/features/reminder-nlp/NaturalLanguageReminderBar.tsx:108
msgid "생성"
msgstr "Create"

#: apps/ui/src/features/reminder-nlp/NaturalLanguageReminderBar.tsx:121
msgid "생성 중"
msgstr "Creating"

#: apps/app/src/controllers/task-view.tsx:28
#: apps/ui/src/features/task-view/TaskViewForm.tsx:161
#: apps/ui/src/features/task/TaskListSort.tsx:34
msgid "생성일"
msgstr "Created"

#: apps/app/src/controllers/settings.tsx:733
msgid "서버 에러 발동"
msgstr "Trigger server error"

#: apps/app/src/controllers/settings.tsx:707
#: apps/app/src/controllers/settings.tsx:712
msgid "서버 에러 테스트"
msgstr "Server error test"

#: apps/app/src/controllers/settings.tsx:282
msgid "서버 에러를 발동했어요"
msgstr "Triggered a server error"

#: apps/ui/src/components/TimezoneSelect.tsx:11
msgid "서울 (KST)"
msgstr "Seoul (KST)"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:241
msgid "선언된 폰트"
msgstr "Declared font"

#: apps/ui/src/features/auth/RevokeSessionDialog.tsx:34
msgid "선택한 기기에서 로그아웃돼요. 다시 이용하려면 그 기기에서 로그인이 필요해요."
msgstr "You'll be signed out on the selected device. You'll need to sign in again on it to use it."

#: apps/ui/src/components/TaskRow.tsx:201
#: apps/ui/src/features/task/TaskBoard.tsx:591
msgid "설명 있음"
msgstr "Has description"

#: apps/ui/src/views/OneTaskView.tsx:372
#: apps/ui/src/views/OneTaskView.tsx:408
msgid "설명 추가"
msgstr "Add description"

#: apps/app/src/controllers/settings.tsx:799
msgid "설명 포함"
msgstr "With description"

#: apps/app/src/controllers/settings.tsx:873
#: apps/app/src/layouts/MobileDashboardShell.tsx:34
#: apps/ui/src/features/team/ProfileMenu.tsx:67
msgid "설정"
msgstr "Settings"

#: apps/app/src/controllers/settings.tsx:885
#: apps/app/src/controllers/settings.tsx:886
msgid "설정 검색"
msgstr "Search settings"

#: apps/ui/src/components/ReminderDayComposer/HourRangePicker.tsx:47
msgid "설정하기"
msgstr "Set up"

#: apps/ui/src/components/ClearReminderConfirmDialog.tsx:37
msgid "설정한 날짜·시각·반복이 모두 사라져요. 되돌릴 수 없어요."
msgstr "The date, time, and repeat you set will all be removed. This can't be undone."

#: apps/ui/src/components/InstallPromptBanner.tsx:97
msgid "설치하기"
msgstr "Install"

#: apps/app/src/controllers/settings.tsx:773
msgid "성공"
msgstr "Success"

#: apps/app/src/controllers/settings.tsx:771
msgid "성공적으로 처리됐어요."
msgstr "Processed successfully."

#: apps/ui/src/components/ReminderDayComposer/QuickTimePresets.tsx:16
msgid "세 시간 뒤"
msgstr "In 3 hr"

#: apps/app/src/controllers/settings.tsx:404
#: apps/app/src/controllers/settings/DevInfoModal.tsx:200
msgid "세션"
msgstr "Session"

#: apps/app/src/queries/Session.ts:23
msgid "세션 목록을 불러오지 못했습니다."
msgstr "Failed to load sessions."

#: apps/app/src/controllers/settings.tsx:611
msgid "세션, 유저, PWA, 푸시 구독 디버그 정보를 봐요."
msgstr "View debug info for session, user, PWA, and push subscription."

#: apps/app/src/queries/Session.ts:80
msgid "세션을 해제하지 못했습니다."
msgstr "Couldn't revoke the session."

#: apps/ui/src/components/ThemeSelect.tsx:21
msgid "세피아"
msgstr "Sepia"

#: shared/features/reminder/labels.ts:15
msgid "셋째 주"
msgstr "3rd week"

#: apps/ui/src/features/team/TeamRoleBadge.tsx:19
msgid "소유자"
msgstr "Owner"

#: apps/ui/src/views/InviteAcceptView.tsx:182
msgid "수락했어요, 이동 중..."
msgstr "Accepted, redirecting..."

#: apps/app/src/controllers/task-view.tsx:29
#: apps/ui/src/features/task-view/TaskViewForm.tsx:162
#: apps/ui/src/features/task/TaskListSort.tsx:35
msgid "수정일"
msgstr "Updated"

#: apps/ui/src/components/ClockTimePicker.tsx:116
#: apps/ui/src/components/ReminderDayComposer/HourDial.tsx:63
msgid "시 선택"
msgstr "Select hour"

#: apps/ui/src/components/ReminderTimeList.tsx:57
msgid "시각 삭제"
msgstr "Remove time"

#: apps/ui/src/components/ReminderDayComposer/HourSection.tsx:23
msgid "시간"
msgstr "hours"

#: apps/ui/src/components/ReminderDayComposer/index.tsx:280
#: apps/ui/src/components/ReminderTimeList.tsx:50
#: apps/ui/src/components/ScheduleComposer.tsx:172
#: apps/ui/src/components/SnoozeReminderModal.tsx:187
#: apps/ui/src/components/TimePickerModal.tsx:28
msgctxt "time-of-day"
msgid "시간"
msgstr "Time"

#: apps/ui/src/components/ReminderTimeList.tsx:73
msgid "시간 추가"
msgstr "Add time"

#: apps/app/src/controllers/settings.tsx:365
msgid "시간대"
msgstr "Timezone"

#: apps/ui/src/components/TimezoneSelect.tsx:23
msgid "시드니"
msgstr "Sydney"

#: apps/ui/src/components/ThemeSelect.tsx:13
msgid "시스템 설정"
msgstr "System"

#: apps/ui/src/components/ScheduleComposer.tsx:131
msgid "시작"
msgstr "Start"

#: apps/ui/src/components/ReminderDayComposer/index.tsx:231
#: apps/ui/src/components/ReminderDayComposer/index.tsx:245
msgid "시작 날짜"
msgstr "Start date"

#: apps/ui/src/components/ReminderDayComposer/HourRangePicker.tsx:69
msgid "시작 시각"
msgstr "Start time"

#: apps/ui/src/components/ScheduleComposer.tsx:263
msgid "시작일을 고른 뒤 마감일을 누르면 기간이 돼요. 하루짜리면 시작일만 고르세요."
msgstr "Pick a start date, then tap an end date to make it a range. For a single day, just pick the start date."

#: apps/ui/src/views/OnboardingView.tsx:318
msgid "시작하기"
msgstr "Get started"

#: apps/ui/src/views/OnboardingView.tsx:235
msgid "시작하기 전에"
msgstr "Before we start"

#: apps/app/src/pages/onboarding/Page.tsx:28
msgid "시작하기에 실패했습니다."
msgstr "Failed to get started."

#: apps/ui/src/components/TimezoneSelect.tsx:36
msgid "시카고 (중부)"
msgstr "Chicago (Central)"

#: apps/app/src/controllers/settings.tsx:160
#: apps/app/src/controllers/settings.tsx:217
msgid "실패"
msgstr "Failed"

#: apps/app/src/components/TaskView.tsx:205
#: apps/app/src/queries/all-tasks.ts:496
msgid "실행취소"
msgstr "Undo"

#: apps/ui/src/components/TimezoneSelect.tsx:16
msgid "싱가포르"
msgstr "Singapore"

#: apps/ui/src/components/TableBubbleMenu.tsx:49
msgid "아래에 행 추가"
msgstr "Add row below"

#: apps/ui/src/components/MediaPicker/MediaPicker.tsx:61
msgid "아이콘"
msgstr "Icon"

#: apps/ui/src/views/NotificationsView.tsx:135
msgid "아직 받은 알림이 없어요."
msgstr "You have no notifications yet."

#: apps/app/src/controllers/channel.tsx:110
msgid "아직 이 채널에 연결된 task가 없어요."
msgstr "No tasks in this channel yet."

#: apps/ui/src/components/CompleteRepeatReminderDialog.tsx:35
msgid "아직 진행 중이 아닌 작업이에요. 완료로 바꾸면 반복 알림이 삭제돼요."
msgstr "This task isn't in progress yet. Marking it complete will delete the recurring reminder."

#: apps/ui/src/features/task/TaskListEmpty.tsx:40
msgid "아직 할일이 없어요"
msgstr "No tasks yet"

#: apps/ui/src/components/SessionList.tsx:60
msgid "알 수 없는 OS"
msgstr "Unknown OS"

#: apps/ui/src/components/SessionList.tsx:45
msgid "알 수 없는 기기"
msgstr "Unknown device"

#: apps/ui/src/components/SessionList.tsx:74
msgid "알 수 없는 브라우저"
msgstr "Unknown browser"

#: apps/app/src/controllers/notifications.tsx:76
#: apps/app/src/controllers/settings.tsx:442
#: apps/app/src/controllers/settings.tsx:446
#: apps/app/src/controllers/settings/PermissionSection.tsx:57
#: apps/ui/src/components/ReminderModal/index.tsx:159
#: apps/ui/src/components/TaskCreateComposer.tsx:793
msgid "알림"
msgstr "Notifications"

#: apps/app/src/controllers/settings.tsx:435
msgid "알림 권한"
msgstr "Notification permission"

#: apps/ui/src/components/ScheduleComposer.tsx:219
#: apps/ui/src/components/ScheduleComposer.tsx:239
msgid "알림 날짜를 일정에 반영"
msgstr "Sync schedule to reminder"

#: apps/ui/src/components/SnoozeReminderModal.tsx:137
msgid "알림 미루기"
msgstr "Snooze reminder"

#: apps/ui/src/components/ReminderDayComposer/RepeatModeToggle.tsx:29
msgid "알림 반복 여부"
msgstr "Reminder repeat"

#: apps/ui/src/components/ReminderList.tsx:100
msgid "알림 삭제"
msgstr "Remove reminder"

#: shared/features/reminder/utils.ts:118
msgid "알림 없음"
msgstr "No reminder"

#: apps/ui/src/components/ReminderModal/index.tsx:303
msgid "알림 적용"
msgstr "Apply reminder"

#: apps/app/src/controllers/settings/PermissionSection.tsx:67
#: apps/app/src/hooks/UseNotificationNudge.ts:48
msgid "알림 켜기"
msgstr "Enable notifications"

#: apps/app/src/controllers/settings.tsx:446
#: apps/app/src/controllers/settings.tsx:452
#: apps/app/src/controllers/settings.tsx:464
msgid "알림 테스트"
msgstr "Test notification"

#: apps/ui/src/components/ReminderDayComposer/ClearReminderButton.tsx:29
msgid "알림 해제"
msgstr "Turn off reminder"

#: apps/ui/src/components/DeferReminderDialog.tsx:64
msgid "알림 해제하고 완료"
msgstr "Clear reminder and complete"

#: apps/app/src/lib/SnoozeToast.ts:31
msgid "알림을 미루지 못했어요"
msgstr "Couldn't push the reminder back"

#: apps/app/src/lib/SnoozeToast.ts:17
msgid "알림을 미뤘어요"
msgstr "Reminder snoozed"

#: apps/app/src/hooks/UseNotificationNudge.ts:41
msgid "알림을 켜면 리마인더를 놓치지 않아요"
msgstr "Turn on notifications so you don't miss reminders"

#: apps/app/src/controllers/settings/PermissionSection.tsx:64
msgid "알림을 켜면 할 일 리마인더를 받을 수 있어요."
msgstr "Turn on notifications to get task reminders."

#: apps/ui/src/components/ClearReminderConfirmDialog.tsx:34
#: apps/ui/src/components/CompleteReminderDialog.tsx:34
msgid "알림을 해제할까요?"
msgstr "Turn off the reminder?"

#: apps/app/src/controllers/settings/PermissionSection.tsx:73
msgid "알림이 차단돼 있어요. 브라우저/기기 설정에서 이 앱의 알림을 허용해 주세요."
msgstr "Notifications are blocked. Allow this app's notifications in your browser or device settings."

#: apps/ui/src/components/InstallPromptBanner.tsx:41
msgid "앱 설치 안내"
msgstr "Install app"

#: apps/ui/src/features/onboarding/ThemePreview.tsx:15
msgid "앱 아이콘 새로 뽑기"
msgstr "Pick a new app icon"

#: apps/app/src/pages/desktop-handoff/Page.tsx:20
msgid "앱으로 돌아가는 중이에요..."
msgstr "Returning to the app..."

#: apps/ui/src/components/TimezoneSelect.tsx:39
msgid "앵커리지"
msgstr "Anchorage"

#: apps/ui/src/views/OnboardingView.tsx:182
msgid "어떤 언어를 사용할까요?"
msgstr "Which language would you like to use?"

#: apps/ui/src/views/OnboardingView.tsx:245
msgid "어떤 일을 하시나요?"
msgstr "What kind of work do you do?"

#: apps/ui/src/views/OnboardingView.tsx:239
msgid "어떻게 오셨나요?"
msgstr "How did you find us?"

#: apps/app/src/controllers/settings.tsx:353
#: apps/app/src/controllers/settings.tsx:357
#: apps/ui/src/components/LocaleSelect.tsx:25
msgid "언어"
msgstr "Language"

#: apps/ui/src/views/OnboardingView.tsx:178
msgid "언어를 선택해주세요"
msgstr "Choose your language"

#: apps/ui/src/components/AttachmentUploadDialog.tsx:104
msgid "업로드에 실패했어요"
msgstr "Upload failed"

#: apps/app/src/controllers/settings.tsx:780
msgid "에러"
msgstr "Error"

#: apps/app/src/controllers/settings.tsx:644
msgid "에러 보내기"
msgstr "Send error"

#: apps/app/src/controllers/settings.tsx:622
#: apps/app/src/controllers/settings.tsx:627
msgid "에러 테스트"
msgstr "Error test"

#: apps/app/src/controllers/settings.tsx:236
msgid "에러를 보냈어요"
msgstr "Error sent"

#: apps/ui/src/components/TeamNav/TeamNav.tsx:190
msgid "여기로 팀을 끌어다 놓으세요"
msgstr "Drag a team here"

#: apps/ui/src/components/ReminderDayComposer/QuickTimePresets.tsx:17
msgid "여섯 시간 뒤"
msgstr "In 6 hr"

#: apps/ui/src/features/team/TeamMembersTable.tsx:239
msgid "역할"
msgstr "Role"

#: apps/ui/src/views/NotificationsView.tsx:51
msgid "역할 변경"
msgstr "Role changed"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:299
msgid "연결 해제"
msgstr "Disconnect"

#: apps/ui/src/components/TableBubbleMenu.tsx:77
msgid "열 삭제"
msgstr "Delete column"

#: apps/ui/src/components/editor/LinkRichCard.tsx:73
msgid "열기"
msgstr "Open"

#: apps/ui/src/features/onboarding/TeamNameField.tsx:27
msgid "예: 우리팀"
msgstr "e.g. My team"

#: apps/ui/src/features/reminder-nlp/NaturalLanguageReminderBar.tsx:89
msgid "예) 매주 월요일 오전 9시 팀 스탠드업"
msgstr "e.g. Team standup every Monday at 9 AM"

#. placeholder {0}: res.status
#: apps/app/src/controllers/settings.tsx:278
msgid "예상과 달라요 ({0}) — 서버가 에러를 던지지 않았어요."
msgstr "Unexpected ({0}) — the server didn't throw an error."

#: apps/ui/src/views/OneTaskView.tsx:957
msgid "예정된 다음 알림이 없어요."
msgstr "No upcoming reminders."

#: apps/ui/src/views/PublicLinkDialog.tsx:160
#: apps/ui/src/views/PublicLinkDialog.tsx:383
msgid "오늘 이후 ~ 1년 이내의 날짜를 골라주세요"
msgstr "Pick a date between today and one year from now"

#: apps/ui/src/features/onboarding/ThemePreview.tsx:25
msgid "오늘 할 일"
msgstr "Today's tasks"

#: apps/app/src/controllers/settings.tsx:778
msgid "오류가 발생했어요."
msgstr "Something went wrong."

#: apps/ui/src/components/TableBubbleMenu.tsx:71
msgid "오른쪽에 열 추가"
msgstr "Add column right"

#: apps/app/src/controllers/task-view.tsx:53
#: apps/ui/src/features/task-view/TaskViewForm.tsx:169
#: apps/ui/src/features/task/TaskListSort.tsx:148
msgid "오름차순"
msgstr "Ascending"

#: apps/ui/src/components/ThemeSelect.tsx:24
msgid "오션"
msgstr "Ocean"

#: apps/ui/src/components/ClockTimePicker.tsx:109
#: apps/ui/src/components/ReminderDayComposer/HourDial.tsx:57
msgid "오전"
msgstr "AM"

#: shared/features/reminder/utils.ts:19
msgid "오전 {displayHour}시"
msgstr "{displayHour} AM"

#: shared/features/reminder/utils.ts:83
msgid "오전 {h}:{mm}"
msgstr "{h}:{mm} AM"

#: apps/ui/src/components/TimezoneSelect.tsx:25
msgid "오클랜드"
msgstr "Auckland"

#: apps/app/src/components/OfflineToast.tsx:34
msgid "오프라인 — 변경 사항은 연결되면 자동으로 동기화됩니다."
msgstr "Offline — changes will sync automatically once you're back online."

#: apps/app/src/queries/all-tasks.ts:204
msgid "오프라인에서 한 일부 변경을 저장하지 못했어요."
msgstr "Some offline changes couldn't be saved."

#: apps/ui/src/components/ClockTimePicker.tsx:109
#: apps/ui/src/components/ReminderDayComposer/HourDial.tsx:57
msgid "오후"
msgstr "PM"

#: shared/features/reminder/utils.ts:19
msgid "오후 {displayHour}시"
msgstr "{displayHour} PM"

#: shared/features/reminder/utils.ts:83
msgid "오후 {h}:{mm}"
msgstr "{h}:{mm} PM"

#: apps/ui/src/features/onboarding/ThemePreview.tsx:16
msgid "온보딩 테마 고르기"
msgstr "Pick onboarding theme"

#: apps/app/src/queries/Onboarding.ts:42
msgid "온보딩을 완료하지 못했습니다."
msgstr "Failed to complete onboarding."

#: shared/dto/auth/messages.ts:12
msgid "올바른 이메일 주소를 입력해 주세요."
msgstr "Please enter a valid email address."

#: apps/app/src/App.tsx:259
#: apps/app/src/lib/NativeNotifications.ts:36
#: apps/ui/src/atom/TaskStatusIcon.tsx:55
#: apps/ui/src/components/TaskRow.tsx:310
msgid "완료"
msgstr "Done"

#: apps/ui/src/views/OneTaskView.tsx:889
msgid "완료된 작업에는 알림을 설정할 수 없어요"
msgstr "Completed tasks can't have a reminder"

#: apps/ui/src/views/OneTaskView.tsx:918
msgid "완료된 작업이에요 — 알림 해제만 가능해요"
msgstr "This task is complete — you can only turn off the reminder"

#: apps/ui/src/views/OneTaskView.tsx:943
msgid "완료된 작업이에요. 알림을 새로 설정할 수 없어요 — 해제만 가능해요."
msgstr "This task is complete. You can't set a new reminder — only turning it off is allowed."

#: apps/ui/src/components/CompleteReminderDialog.tsx:37
msgid "완료로 표시해도 예정된 알림은 그대로 남아있어요."
msgstr "Marking it done won't turn off the scheduled reminder."

#: apps/ui/src/components/TableBubbleMenu.tsx:65
msgid "왼쪽에 열 추가"
msgstr "Add column left"

#: apps/ui/src/components/ReminderDayComposer/WeekdayToggleGroup.tsx:27
msgid "요일 선택"
msgstr "Select weekdays"

#: apps/ui/src/components/ReminderDayComposer/MonthlySection.tsx:16
msgid "요일로"
msgstr "By weekday"

#: apps/app/src/controllers/settings.tsx:548
msgid "요청 20개 동시 전송"
msgstr "Send 20 requests at once"

#: apps/app/src/controllers/settings.tsx:537
msgid "요청 20개를 한꺼번에 보내 rate limit(429) 안내 토스트가 뜨는지 확인해요."
msgstr "Sends 20 requests at once to check whether the rate limit (429) toast appears."

#. placeholder {0}: res.status
#: apps/app/src/controllers/settings.tsx:161
#: apps/app/src/controllers/settings.tsx:218
msgid "요청 실패 ({0})"
msgstr "Request failed ({0})"

#: apps/app/src/controllers/settings.tsx:584
msgid "요청 중... (약 4초)"
msgstr "Requesting... (~4s)"

#: apps/app/src/controllers/settings.tsx:595
msgid "요청에 실패했어요."
msgstr "The request failed."

#: apps/app/src/pages/rate-limited/Page.tsx:65
msgid "요청이 너무 많아요"
msgstr "Too many requests"

#: apps/app/src/lib/rateLimitNotice.ts:25
msgid "요청이 너무 많아요. 잠시 후 다시 시도해주세요."
msgstr "Too many requests. Please try again in a moment."

#: apps/app/src/queries/ReminderNlp.ts:47
#: apps/app/src/queries/ReminderNlp.ts:106
msgid "요청이 많아요. 잠시 후 다시 시도해주세요."
msgstr "Too many requests. Please try again in a moment."

#: apps/ui/src/components/TimezoneSelect.tsx:34
msgid "요하네스버그"
msgstr "Johannesburg"

#: apps/app/src/controllers/settings.tsx:562
msgid "워치독"
msgstr "Watchdog"

#: apps/ui/src/components/TableBubbleMenu.tsx:43
msgid "위에 행 추가"
msgstr "Add row above"

#: apps/app/src/controllers/settings/PermissionSection.tsx:82
msgid "위치"
msgstr "Location"

#: apps/app/src/controllers/settings/PermissionSection.tsx:88
msgid "위치가 차단돼 있어요. 브라우저/기기 설정에서 허용할 수 있어요."
msgstr "Location is blocked. You can allow it in your browser or device settings."

#: apps/app/src/controllers/settings/DevInfoModal.tsx:215
msgid "유저"
msgstr "User"

#: apps/ui/src/components/CompleteReminderDialog.tsx:49
msgid "유지"
msgstr "Keep"

#: apps/ui/src/views/PublicLinkDialog.tsx:278
msgid "유효기간 변경"
msgstr "Change expiration"

#: apps/ui/src/views/PublicLinkDialog.tsx:144
msgid "유효기간을 변경했어요"
msgstr "Changed the expiration"

#: shared/dto/auth/messages.ts:43
msgid "유효하지 않은 초대예요."
msgstr "This invitation is not valid."

#: apps/ui/src/components/TaskCreateComposer.tsx:1280
msgid "음성 입력 중지"
msgstr "Stop voice input"

#: apps/ui/src/components/TaskCreateComposer.tsx:1280
msgid "음성으로 입력"
msgstr "Voice input"

#: apps/app/src/controllers/settings/SessionsModal.tsx:39
msgid "이 계정으로 로그인된 기기와 브라우저 목록이에요."
msgstr "Devices and browsers signed in to this account."

#: apps/app/src/controllers/settings.tsx:500
msgid "이 계정의 모든 기기로 테스트 웹 푸시를 보내요."
msgstr "Sends a test web push to every device on this account."

#: apps/ui/src/features/auth/RevokeSessionDialog.tsx:31
msgid "이 기기를 해제할까요?"
msgstr "Revoke this device?"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:273
msgid "이 기기에 등록된 구독이 없어요."
msgstr "No subscription registered on this device."

#: apps/app/src/controllers/settings/DevInfoModal.tsx:268
msgid "이 브라우저는 Web Push를 지원하지 않아요."
msgstr "This browser doesn't support Web Push."

#: apps/ui/src/views/OneTaskMenu.tsx:162
msgid "이 작업을 보관할까요?"
msgstr "Archive this task?"

#: apps/ui/src/views/InviteAcceptView.tsx:152
msgid "이 초대는 {invitedEmail} 앞으로 왔어요. 해당 계정으로 다시 로그인해 주세요."
msgstr "This invitation was sent to {invitedEmail}. Please sign in again with that account."

#: apps/ui/src/views/InviteAcceptView.tsx:154
msgid "이 초대는 다른 이메일 주소로 왔어요. 해당 계정으로 다시 로그인해 주세요."
msgstr "This invitation was sent to a different email address. Please sign in again with that account."

#: apps/app/src/layouts/dashboard/Service.ts:1085
msgid "이동"
msgstr "Move"

#: apps/ui/src/features/team/TeamMembersTable.tsx:235
#: apps/ui/src/features/user/NicknameInput.tsx:28
msgid "이름"
msgstr "Name"

#: apps/ui/src/features/team/FolderItemMenu.tsx:140
msgid "이름 바꾸기"
msgstr "Rename"

#: apps/ui/src/features/user/NicknameInput.tsx:42
msgid "이름을 입력하세요"
msgstr "Enter your name"

#: apps/app/src/controllers/settings/ProfileModal.tsx:154
msgid "이름을 입력해주세요."
msgstr "Please enter a name."

#: apps/app/src/queries/User.ts:31
msgid "이름을 저장하지 못했습니다."
msgstr "Failed to save your name."

#: apps/ui/src/features/auth/EmailField.tsx:33
msgid "이메일"
msgstr "Email"

#: shared/dto/auth/messages.ts:38
#: shared/dto/auth/messages.ts:39
#: shared/dto/auth/messages.ts:40
msgid "이메일 또는 비밀번호가 올바르지 않습니다."
msgstr "Invalid email or password."

#: apps/ui/src/features/team/InviteMemberDialog.tsx:50
msgid "이메일로 팀에 새 멤버를 초대해요."
msgstr "Invite new members to your team by email."

#: shared/dto/auth/messages.ts:11
msgid "이메일을 입력해 주세요."
msgstr "Please enter your email."

#: apps/ui/src/components/MediaPicker/MediaPicker.tsx:64
msgid "이모지"
msgstr "Emoji"

#: shared/dto/auth/messages.ts:41
msgid "이미 가입된 이메일이에요."
msgstr "This email is already registered."

#: apps/ui/src/components/DuplicateTaskBanner.tsx:37
msgid "이미 비슷한 할 일이 있어요"
msgstr "There's already a similar task"

#: apps/app/src/lib/SnoozeToast.ts:40
msgid "이미 지난 알림이에요"
msgstr "This reminder has already passed"

#: apps/app/src/layouts/dashboard/Service.ts:1215
msgid "이미 초대한 이메일이에요. 아래 목록에서 대기 중인 초대를 확인하세요."
msgstr "This email has already been invited. Check the pending invitations in the list below."

#: apps/app/src/layouts/dashboard/Service.ts:1217
msgid "이미 팀에 속한 멤버예요."
msgstr "This person is already a team member."

#: apps/ui/src/components/MediaPicker/UploadPanel.tsx:159
msgid "이미지 URL"
msgstr "Image URL"

#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:244
#: apps/ui/src/components/MediaPicker/UploadPanel.tsx:158
msgid "이미지 URL 붙여넣기"
msgstr "Paste image URL"

#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:205
#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:210
msgid "이미지 업로드"
msgstr "Upload image"

#: apps/app/src/hooks/PendingImageUploadGuard.tsx:48
msgid "이미지 업로드가 아직 진행 중이에요"
msgstr "Images are still uploading"

#: apps/ui/src/components/MediaPicker/UploadPanel.tsx:145
msgid "이미지 파일 선택"
msgstr "Choose image file"

#: apps/app/src/controllers/settings/ProfileModal.tsx:76
msgid "이미지는 25MB 이하만 올릴 수 있어요."
msgstr "Images must be 25MB or smaller."

#: apps/app/src/controllers/settings.tsx:304
msgid "이슈를 리포트했어요"
msgstr "Issue reported"

#: apps/ui/src/components/TimezoneSelect.tsx:32
msgid "이스탄불"
msgstr "Istanbul"

#: apps/ui/src/views/OnboardingView.tsx:228
#: apps/ui/src/views/OnboardingView.tsx:265
#: apps/ui/src/views/OnboardingView.tsx:301
#: apps/ui/src/views/OnboardingView.tsx:329
msgid "이전"
msgstr "Back"

#: apps/ui/src/atom/Calendar.tsx:38
#: apps/ui/src/components/ReminderDayComposer/YearlySection.tsx:52
msgid "이전 달"
msgstr "Previous month"

#: apps/ui/src/views/VerifyEmailView.tsx:100
msgid "인증 코드"
msgstr "Verification code"

#: shared/dto/auth/messages.ts:19
msgid "인증 코드 6자리를 모두 입력해 주세요."
msgstr "Please enter all 6 digits of the code."

#: apps/ui/src/views/VerifyEmailView.tsx:124
msgid "인증 코드 다시 보내기"
msgstr "Resend verification code"

#: apps/ui/src/views/LoginView.tsx:66
msgid "인증 코드 받기"
msgstr "Get verification code"

#: apps/app/src/pages/verify-email/Page.tsx:53
msgid "인증 코드 발송에 실패했습니다."
msgstr "Failed to send verification code."

#: apps/ui/src/views/VerifyEmailView.tsx:73
msgid "인증 코드를 입력하세요"
msgstr "Enter verification code"

#: shared/dto/auth/messages.ts:18
msgid "인증 코드를 입력해 주세요."
msgstr "Please enter the verification code."

#: apps/app/src/pages/verify-email/Page.tsx:33
msgid "인증에 실패했습니다. 코드를 다시 확인해 주세요."
msgstr "Verification failed. Please check the code and try again."

#: apps/ui/src/views/VerifyEmailView.tsx:112
msgid "인증하고 시작하기"
msgstr "Verify and get started"

#: apps/ui/src/components/ReminderDayComposer/DailySection.tsx:16
msgid "일"
msgstr "days"

#: apps/app/src/controllers/settings.tsx:571
msgid "일부러 4초 걸리는 요청을 보내, 3초 넘는 느린 /api 요청을 PostHog Error tracking 으로 보고하는 소프트 워치독이 도는지 확인해요. 실제 전송은 프로덕션 빌드에서만 되고, 엔드포인트당 1회만 보고돼요."
msgstr "Sends a deliberately 4s-long request to verify the soft watchdog that reports slow /api requests (over 3s) to PostHog Error tracking. Actual sending happens only in production builds, and each endpoint is reported once."

#: apps/app/src/controllers/task-view.tsx:30
#: apps/ui/src/components/TaskCreateComposer.tsx:802
#: apps/ui/src/features/task-view/TaskViewForm.tsx:163
#: apps/ui/src/features/task/TaskListSort.tsx:36
msgid "일정"
msgstr "Schedule"

#: apps/ui/src/components/TaskCreateComposer.tsx:1248
#: apps/ui/src/views/OneTaskView.tsx:819
msgid "일정 설정"
msgstr "Set schedule"

#: shared/features/reminder/utils.ts:32
#: shared/features/task/utils.ts:102
msgid "일정 없음"
msgstr "No schedule"

#: apps/ui/src/components/TaskRow.tsx:194
#: apps/ui/src/features/task/TaskBoard.tsx:581
msgid "일정 있음"
msgstr "Has schedule"

#: apps/ui/src/components/ScheduleComposer.tsx:210
msgid "일정 지우기"
msgstr "Clear schedule"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:153
msgid "일정을 다른 캘린더 앱에서도 볼 수 있어요."
msgstr "View your schedule in other calendar apps too."

#: shared/dto/auth/messages.ts:13
msgid "일회용/임시 이메일 주소로는 가입할 수 없어요. 다른 이메일을 사용해 주세요."
msgstr "Disposable or temporary email addresses can't be used to sign up. Please use a different email."

#: apps/app/src/pages/desktop-handoff/Page.tsx:26
msgid "자동으로 열리지 않았다면 여기를 클릭하세요"
msgstr "If it didn't open automatically, click here"

#: apps/app/src/queries/ReminderNlp.ts:43
#: apps/app/src/queries/ReminderNlp.ts:103
msgid "자연어 생성이 아직 준비되지 않았어요."
msgstr "Natural language generation isn't ready yet."

#: apps/ui/src/features/reminder-nlp/NaturalLanguageReminderBar.tsx:87
msgid "자연어 입력"
msgstr "Natural language input"

#: apps/ui/src/components/TimezoneSelect.tsx:18
msgid "자카르타"
msgstr "Jakarta"

#: apps/ui/src/views/OneTaskMenu.tsx:77
#: apps/ui/src/views/OneTaskMenu.tsx:92
msgid "작업 메뉴"
msgstr "Task menu"

#: apps/app/src/pages/rate-limited/Page.tsx:67
msgid "잠시만 기다려 주세요. 곧 다시 이용할 수 있어요."
msgstr "Please wait a moment. You'll be able to continue shortly."

#: apps/app/src/controllers/settings.tsx:683
msgid "잡히지 않은 예외"
msgstr "Uncaught exception"

#: apps/app/src/controllers/settings.tsx:250
msgid "잡히지 않은 예외를 던졌어요"
msgstr "Threw an uncaught exception"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:291
msgid "재발급"
msgstr "Reissue"

#: apps/ui/src/views/ForgotPasswordView.tsx:98
msgid "재설정 링크 보내기"
msgstr "Send reset link"

#: apps/ui/src/views/ForgotPasswordView.tsx:68
msgid "재설정 링크를 이메일로 보냈어요. 메일함을 확인해 주세요."
msgstr "We sent a reset link to your email. Please check your inbox."

#: apps/app/src/pages/forgot-password/Page.tsx:27
msgid "재설정 메일 발송에 실패했습니다."
msgstr "Failed to send reset email."

#: apps/app/src/controllers/settings/ProfileModal.tsx:163
#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:362
#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:363
#: apps/ui/src/components/TaskCreateComposer.tsx:1298
#: apps/ui/src/features/channel/EditChannelDialog.tsx:22
#: apps/ui/src/features/team/FolderItemMenu.tsx:73
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:139
#: apps/ui/src/features/team/TeamSettingsSection.tsx:86
#: apps/ui/src/views/OneTaskView.tsx:879
msgid "저장"
msgstr "Save"

#: apps/app/src/controllers/settings/ProfileModal.tsx:120
msgid "저장하지 못했습니다."
msgstr "Couldn't save."

#: apps/app/src/controllers/settings/ProfileModal.tsx:117
msgid "저장했어요."
msgstr "Saved."

#: apps/ui/src/components/AvatarCropModal.tsx:109
#: apps/ui/src/components/MediaPicker/UploadPanel.tsx:167
msgid "적용"
msgstr "Apply"

#: apps/ui/src/views/OnboardingView.tsx:285
msgid "전송 버튼을 꾹 누르고 있으면 AI 가 대신 만들어줘요"
msgstr "Hold down the send button and AI will make it for you"

#: apps/app/src/controllers/settings.tsx:232
msgid "전송 실패 — 개발 빌드이거나 VITE_PUBLIC_POSTHOG_KEY가 없어요."
msgstr "Send failed — this is a dev build or VITE_PUBLIC_POSTHOG_KEY is missing."

#. placeholder {0}: res.status
#: apps/app/src/controllers/settings.tsx:300
msgid "전송 실패 ({0})"
msgstr "Send failed ({0})"

#. placeholder {0}: testNotificationStatus.message
#. placeholder {0}: testPushStatus.message
#: apps/app/src/controllers/settings.tsx:475
#: apps/app/src/controllers/settings.tsx:520
msgid "전송 실패: {0}"
msgstr "Send failed: {0}"

#: apps/app/src/controllers/settings.tsx:464
#: apps/app/src/controllers/settings.tsx:509
#: apps/app/src/controllers/settings.tsx:548
msgid "전송 중..."
msgstr "Sending..."

#: apps/app/src/controllers/settings.tsx:515
msgid "전송했어요. 브라우저 알림을 확인해 보세요."
msgstr "Sent. Check your browser notifications."

#: apps/ui/src/components/TaskStatusDropdown.tsx:120
#: apps/ui/src/features/task/TaskListView.tsx:139
#: apps/ui/src/features/team/AssigneeDropdown.tsx:92
msgid "전체"
msgstr "All"

#: apps/app/src/controllers/all-tasks.tsx:63
#: apps/app/src/layouts/MobileDashboardShell.tsx:33
msgid "전체 할일"
msgstr "All tasks"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:256
#: apps/ui/src/components/AttachmentList.tsx:212
msgid "접기"
msgstr "Collapse"

#: apps/ui/src/features/task-view/TaskViewForm.tsx:266
#: apps/ui/src/features/task/TaskListSort.tsx:84
#: apps/ui/src/features/task/TaskListSort.tsx:92
#: apps/ui/src/features/task/TaskListSort.tsx:98
msgid "정렬"
msgstr "Sort"

#: apps/ui/src/features/task-view/TaskViewForm.tsx:270
#: apps/ui/src/features/task/TaskListSort.tsx:105
#: apps/ui/src/features/task/TaskListSort.tsx:107
msgid "정렬 기준"
msgstr "Sort by"

#: apps/ui/src/features/task-view/TaskViewForm.tsx:276
msgid "정렬 방향"
msgstr "Sort direction"

#: apps/app/src/controllers/settings.tsx:603
#: apps/app/src/controllers/settings.tsx:615
msgid "정보 확인"
msgstr "View info"

#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:390
#: apps/ui/src/components/editor/LinkRichCard.tsx:76
#: apps/ui/src/components/MediaPicker/UploadPanel.tsx:126
#: apps/ui/src/features/team/RemoveMemberDialog.tsx:56
msgid "제거"
msgstr "Remove"

#: apps/ui/src/features/team/RemoveMemberDialog.tsx:37
msgid "제거하면 이 팀의 작업과 정보에 더 이상 접근할 수 없어요."
msgstr "Once removed, they'll lose access to this team's tasks and data."

#: apps/app/src/controllers/task-view.tsx:31
#: apps/ui/src/components/TaskCreateComposer.tsx:1028
#: apps/ui/src/features/task-view/TaskViewForm.tsx:164
#: apps/ui/src/features/task/TaskListSort.tsx:37
#: apps/ui/src/views/OneTaskView.tsx:704
msgid "제목"
msgstr "Title"

#: apps/app/src/controllers/settings.tsx:672
msgid "제목 (선택) — 예외 메시지에 들어가요"
msgstr "Title (optional) — included in the exception message"

#: apps/app/src/controllers/settings.tsx:640
#: apps/app/src/controllers/settings.tsx:724
msgid "제목 (선택) — 이슈 제목이자 그룹핑 키"
msgstr "Title (optional) — issue title and grouping key"

#: apps/app/src/controllers/one-task.tsx:230
#: apps/app/src/layouts/dashboard/Service.ts:1143
#: apps/ui/src/views/OneTaskView.tsx:706
#: apps/ui/src/views/PublicTaskView.tsx:129
#: apps/ui/src/views/PublicTaskView.tsx:232
msgid "제목 없음"
msgstr "Untitled"

#: apps/app/src/controllers/settings.tsx:794
msgid "제목이 있는 토스트"
msgstr "Toast with a title"

#: apps/app/src/components/SubtaskTaskList.tsx:69
msgid "조건에 맞는 하위 작업이 없어요."
msgstr "No subtasks match the filter."

#: apps/ui/src/features/task/TaskListEmpty.tsx:40
msgid "조건에 맞는 할일이 없어요"
msgstr "No tasks match your filters"

#: apps/app/src/controllers/task-view.tsx:95
msgid "존재하지 않는 view 예요."
msgstr "This view doesn't exist."

#: apps/app/src/pages/__root.tsx:9
msgid "존재하지 않는 페이지예요."
msgstr "This page doesn't exist."

#: apps/ui/src/components/ScheduleComposer.tsx:131
msgid "종료"
msgstr "End"

#: apps/ui/src/components/ReminderDayComposer/HourRangePicker.tsx:72
msgid "종료 시각"
msgstr "End time"

#: apps/ui/src/components/ScheduleComposer.tsx:181
#: apps/ui/src/components/ScheduleComposer.tsx:184
#: shared/features/reminder/utils.ts:80
msgid "종일"
msgstr "All day"

#: apps/ui/src/components/ReminderDayComposer/WeeklySection.tsx:23
msgid "주"
msgstr "weeks"

#: apps/app/src/controllers/settings.tsx:785
msgid "주의가 필요해요."
msgstr "This needs your attention."

#: apps/ui/src/components/FavoritesNav.tsx:236
msgid "즐겨찾기"
msgstr "Favorites"

#: apps/app/src/layouts/MobileDashboardShell.tsx:32
msgid "즐겨찾기 및 팀"
msgstr "Favorites & Teams"

#: apps/ui/src/components/PageTitleBar.tsx:37
#: apps/ui/src/components/TaskRow.tsx:251
#: apps/ui/src/components/TeamNav/ChannelRow.tsx:59
#: apps/ui/src/components/TeamNav/TeamRow.tsx:79
#: apps/ui/src/views/OneTaskView.tsx:622
msgid "즐겨찾기 추가"
msgstr "Add to favorites"

#: apps/ui/src/components/FavoritesNav.tsx:108
#: apps/ui/src/components/PageTitleBar.tsx:37
#: apps/ui/src/components/TaskRow.tsx:251
#: apps/ui/src/components/TeamNav/ChannelRow.tsx:59
#: apps/ui/src/components/TeamNav/TeamRow.tsx:79
#: apps/ui/src/views/OneTaskView.tsx:622
msgid "즐겨찾기 해제"
msgstr "Remove from favorites"

#: apps/app/src/hooks/PendingImageUploadGuard.tsx:51
msgid "지금 나가면 첨부가 취소돼요. 나가시겠어요?"
msgstr "Leaving now cancels the attachment. Leave anyway?"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:166
msgid "지금 시점의 일정을 .ics 파일로 한 번 내려받아요. 이후 일정이 바뀌어도 자동으로 갱신되지 않아요."
msgstr "Download your current schedule once as an .ics file. It won't update automatically when your schedule changes later."

#: apps/ui/src/components/ReminderDayComposer/index.tsx:236
msgid "지금부터"
msgstr "From now"

#: apps/ui/src/components/ReminderDayComposer/index.tsx:305
msgid "지금부터로 되돌리기"
msgstr "Reset to from now"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:184
#: apps/app/src/controllers/settings/PermissionSection.tsx:24
msgid "지원 안 함"
msgstr "Not supported"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:177
msgid "지원 안 함 (iOS Safari 전용 속성)"
msgstr "Not supported (iOS Safari-only property)"

#: apps/ui/src/views/OnboardingView.tsx:55
msgid "지인 추천"
msgstr "Word of mouth"

#: apps/app/src/controllers/settings.tsx:741
msgid "직접 리포트"
msgstr "Report directly"

#: apps/ui/src/views/PublicLinkDialog.tsx:305
#: apps/ui/src/views/PublicLinkDialog.tsx:367
msgid "직접 선택"
msgstr "Choose manually"

#: apps/ui/src/components/MediaPicker/MediaPicker.tsx:67
msgid "직접 업로드"
msgstr "Upload"

#: apps/app/src/controllers/task-view.tsx:32
#: apps/ui/src/features/task-view/TaskViewForm.tsx:166
#: apps/ui/src/features/task/TaskListSort.tsx:43
msgid "직접 정렬"
msgstr "Manual order"

#: apps/ui/src/components/SnoozeReminderModal.tsx:177
msgid "직접 지정"
msgstr "Custom time"

#: apps/app/src/controllers/settings.tsx:660
msgid "진짜 잡히지 않는 브라우저 예외를 던져 자동 수집(capture_exceptions)이 도는지 확인해요. \"에러 테스트\"(수동 전송)와 달리 window.onerror/unhandledrejection 경로를 타요. \"렌더 크래시\"는 최상위 ErrorBoundary를 발동해요 — 앱이 폴백 화면으로 바뀌니 새로고침해야 돌아와요."
msgstr "Throws a genuinely uncaught browser exception to check that auto-capture (capture_exceptions) runs. Unlike \"Error test\" (manual send), it goes through the window.onerror/unhandledrejection path. \"Render crash\" triggers the top-level ErrorBoundary — the app switches to a fallback screen, so you'll need to refresh to return."

#: apps/ui/src/atom/TaskStatusIcon.tsx:54
msgid "진행 중"
msgstr "In progress"

#: apps/ui/src/components/DeferReminderDialog.tsx:39
msgid "진행 중인 반복 알림 작업이에요. 완료하는 대신 다음 회차로 미루거나, 알림을 해제하고 완료할 수 있어요."
msgstr "This task has a repeating reminder in progress. Instead of completing it, you can defer it to the next occurrence, or clear the reminder and complete it."

#: apps/ui/src/components/TaskCreateComposer.tsx:326
#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:140
msgid "채널"
msgstr "Channel"

#: apps/ui/src/features/channel/ChannelPicker.tsx:54
msgid "채널 검색"
msgstr "Search channels"

#: apps/ui/src/features/channel/ChannelPicker.tsx:55
msgid "채널 검색…"
msgstr "Search channels…"

#: apps/ui/src/features/channel/ChannelItemMenu.tsx:42
msgid "채널 메뉴"
msgstr "Channel menu"

#: apps/ui/src/features/channel/ChannelItemMenu.tsx:88
msgid "채널 삭제하기"
msgstr "Delete channel"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:247
msgid "채널 선택"
msgstr "Select channel"

#: apps/ui/src/components/TaskCreateComposer.tsx:432
msgid "채널 설정"
msgstr "Channel settings"

#: apps/ui/src/features/channel/ChannelItemMenu.tsx:76
#: apps/ui/src/features/channel/EditChannelDialog.tsx:19
msgid "채널 수정하기"
msgstr "Edit channel"

#: apps/ui/src/features/channel/ChannelFormDialog.tsx:69
#: apps/ui/src/features/channel/ChannelFormDialog.tsx:70
msgid "채널 이름"
msgstr "Channel name"

#: apps/ui/src/features/channel/EditChannelDialog.tsx:20
msgid "채널 이름을 수정해주세요."
msgstr "Update the channel name."

#: apps/ui/src/features/channel/CreateChannelDialog.tsx:24
msgid "채널 이름을 입력해주세요."
msgstr "Please enter a channel name."

#: apps/app/src/layouts/dashboard/Service.ts:363
msgid "채널을 즐겨찾기에 추가했어요"
msgstr "Added the channel to favorites"

#: apps/app/src/layouts/dashboard/Service.ts:373
msgid "채널을 즐겨찾기에서 제거했어요"
msgstr "Removed the channel from favorites"

#: apps/app/src/controllers/channel.tsx:34
msgid "채널을 찾을 수 없어요."
msgstr "Channel not found."

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:243
msgid "채널이 없어요"
msgstr "No channels"

#: apps/app/src/controllers/settings/DeleteAccountModal.tsx:89
#: apps/ui/src/views/ForgotPasswordView.tsx:98
#: apps/ui/src/views/LoginView.tsx:131
#: apps/ui/src/views/LoginView.tsx:218
#: apps/ui/src/views/OnboardingView.tsx:318
#: apps/ui/src/views/ResetPasswordView.tsx:128
#: apps/ui/src/views/VerifyEmailView.tsx:112
msgid "처리 중..."
msgstr "Processing..."

#. placeholder {0}: items.length
#: apps/ui/src/components/AttachmentList.tsx:111
msgid "첨부파일 ({0})"
msgstr "Attachments ({0})"

#: apps/ui/src/components/AttachmentButton.tsx:38
#: apps/ui/src/components/AttachmentUploadDialog.tsx:137
msgid "첨부파일 추가"
msgstr "Add attachment"

#: apps/ui/src/components/AttachmentUploadDialog.tsx:202
msgid "첨부할 파일 선택"
msgstr "Choose files to attach"

#: apps/ui/src/features/task/TaskListEmpty.tsx:47
msgid "첫 할일을 만들어보세요."
msgstr "Create your first task."

#: shared/features/reminder/labels.ts:13
msgid "첫째 주"
msgstr "1st week"

#: apps/ui/src/atom/MonthlyDateGrid.tsx:166
msgid "초기화"
msgstr "Reset"

#: apps/ui/src/features/team/InviteMemberButton.tsx:22
msgid "초대"
msgstr "Invite"

#: apps/app/src/layouts/dashboard/Service.ts:1225
msgid "초대 메일을 보냈어요."
msgstr "Invitation email sent."

#: apps/ui/src/features/team/InviteMemberDialog.tsx:61
msgid "초대 보내기"
msgstr "Send invite"

#: apps/ui/src/views/InviteAcceptView.tsx:182
msgid "초대 수락"
msgstr "Accept invitation"

#: apps/ui/src/features/team/TeamMembersTable.tsx:206
msgid "초대 수락 대기 중"
msgstr "Awaiting acceptance"

#: apps/app/src/pages/invite/Page.tsx:111
msgid "초대 수락에 실패했어요."
msgstr "Failed to accept the invitation."

#: apps/ui/src/features/team/CancelInvitationDialog.tsx:56
msgid "초대 취소"
msgstr "Cancel invitation"

#: apps/app/src/layouts/dashboard/Service.ts:1234
msgid "초대 취소에 실패했어요."
msgstr "Failed to cancel the invitation."

#: apps/ui/src/features/team/TeamMembersTable.tsx:214
msgid "초대됨"
msgstr "Invited"

#: apps/app/src/layouts/dashboard/Service.ts:1221
msgid "초대를 보내지 못했어요."
msgstr "Failed to send the invitation."

#: apps/ui/src/views/InviteAcceptView.tsx:178
msgid "초대를 수락하면 팀 목록에 추가돼요."
msgstr "Accepting the invitation adds the team to your list."

#: apps/ui/src/views/InviteAcceptView.tsx:130
msgid "초대를 찾을 수 없어요"
msgstr "Invitation not found"

#: apps/ui/src/views/InviteAcceptView.tsx:107
msgid "초대를 확인하려면 로그인하거나 가입해 주세요."
msgstr "Sign in or sign up to view the invitation."

#: apps/ui/src/views/LoginView.tsx:281
msgid "최근 사용"
msgstr "Recently used"

#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:190
#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:254
msgid "추가"
msgstr "Add"

#: apps/app/src/controllers/settings/ProfileModal.tsx:160
#: apps/ui/src/components/AvatarCropModal.tsx:106
#: apps/ui/src/components/ClearReminderConfirmDialog.tsx:46
#: apps/ui/src/components/CompleteRepeatReminderDialog.tsx:44
#: apps/ui/src/features/auth/RevokeOtherSessionsDialog.tsx:46
#: apps/ui/src/features/auth/RevokeSessionDialog.tsx:45
#: apps/ui/src/features/channel/ChannelFormDialog.tsx:76
#: apps/ui/src/features/channel/ChannelItemMenu.tsx:117
#: apps/ui/src/features/team/CreateFolderDialog.tsx:67
#: apps/ui/src/features/team/CreateTeamDialog.tsx:115
#: apps/ui/src/features/team/FolderItemMenu.tsx:70
#: apps/ui/src/features/team/InviteMemberDialog.tsx:58
#: apps/ui/src/features/team/LogoutConfirmDialog.tsx:39
#: apps/ui/src/features/team/RemoveMemberDialog.tsx:46
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:96
#: apps/ui/src/views/OneTaskMenu.tsx:177
#: apps/ui/src/views/OneTaskView.tsx:859
#: apps/ui/src/views/PublicLinkDialog.tsx:213
msgid "취소"
msgstr "Cancel"

#: apps/ui/src/atom/TaskStatusIcon.tsx:56
msgid "취소됨"
msgstr "Canceled"

#: apps/ui/src/features/team/CancelInvitationDialog.tsx:37
msgid "취소하면 이 초대 링크로는 더 이상 팀에 참여할 수 없어요."
msgstr "If you cancel, this invitation link can no longer be used to join the team."

#: apps/ui/src/components/TimezoneSelect.tsx:33
msgid "카이로"
msgstr "Cairo"

#: apps/app/src/controllers/calendar.tsx:105
msgid "캘린더"
msgstr "Calendar"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:150
msgid "캘린더 내보내기"
msgstr "Export calendar"

#: apps/ui/src/components/ScheduleComposer.tsx:222
msgid "켜두면 알림을 저장할 때마다, 그리고 반복 알림이 다음 회차로 넘어갈 때 일정이 알림 날짜로 따라가요. 일정을 바꿔도 알림은 그대로예요."
msgstr "When on, the schedule follows the reminder date every time you save a reminder, and moves to the next occurrence when a repeating reminder rolls over. Changing the schedule never touches the reminder."

#: apps/app/src/controllers/settings/PermissionSection.tsx:18
msgid "켜짐"
msgstr "On"

#: apps/app/src/controllers/settings.tsx:652
#: apps/app/src/controllers/settings.tsx:657
msgid "클라이언트 예외 테스트"
msgstr "Client exception test"

#: apps/ui/src/components/MediaPicker/UploadPanel.tsx:140
msgid "클릭하거나 파일을 끌어다 놓으세요"
msgstr "Click or drag and drop a file"

#: apps/ui/src/components/TimezoneSelect.tsx:14
msgid "타이베이"
msgstr "Taipei"

#: apps/app/src/controllers/settings.tsx:365
#: apps/app/src/controllers/settings.tsx:369
#: apps/ui/src/components/TimezoneSelect.tsx:67
msgid "타임존"
msgstr "Time zone"

#: apps/ui/src/components/TimezoneSelect.tsx:73
msgid "타임존 검색…"
msgstr "Search time zones…"

#: apps/app/src/queries/User.ts:17
msgid "타임존을 저장하지 못했습니다."
msgstr "Failed to save time zone."

#: apps/app/src/controllers/settings.tsx:392
#: apps/app/src/controllers/settings.tsx:396
#: apps/ui/src/components/ThemeSelect.tsx:39
msgid "테마"
msgstr "Theme"

#: apps/ui/src/views/OnboardingView.tsx:200
msgid "테마를 골라주세요"
msgstr "Choose a theme"

#: apps/app/src/controllers/settings.tsx:630
msgid "테스트 에러를 PostHog로 보내요. 앱은 멈추지 않아요. 라벨이 그대로 이슈 제목이 돼요."
msgstr "Sends a test error to PostHog. The app keeps running. The label becomes the issue title."

#: apps/ui/src/components/TimezoneSelect.tsx:42
msgid "토론토"
msgstr "Toronto"

#: apps/app/src/controllers/settings.tsx:749
msgid "토스트 테스트"
msgstr "Toast test"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:139
#: apps/ui/src/features/task-view/TaskViewForm.tsx:217
#: apps/ui/src/features/task-view/TaskViewForm.tsx:218
msgid "팀"
msgstr "Team"

#. placeholder {0}: team.name
#. placeholder {0}: teamNames.get(view.teamId) ?? "?"
#: apps/app/src/controllers/task-view.tsx:39
#: apps/ui/src/features/task-view/TaskViewForm.tsx:175
msgid "팀 · {0}"
msgstr "Team · {0}"

#. placeholder {0}: teamIds.map((id) => teamNames.get(id) ?? "?").join(", ")
#: apps/app/src/controllers/task-view.tsx:41
msgid "팀 {0}"
msgstr "Team {0}"

#: apps/ui/src/features/team/TeamDropdown.tsx:103
msgid "팀 검색"
msgstr "Search teams"

#: apps/ui/src/features/team/TeamDropdown.tsx:109
msgid "팀 검색…"
msgstr "Search teams…"

#: apps/ui/src/features/team/TeamSettingsDialog.tsx:148
msgid "팀 나가기"
msgstr "Leave team"

#: apps/ui/src/features/team/TeamSettingsSection.tsx:47
msgid "팀 로고 변경"
msgstr "Change team logo"

#: apps/ui/src/features/team/TeamItemMenu.tsx:50
#: apps/ui/src/features/team/TeamMenu.tsx:38
#: apps/ui/src/features/team/TeamMenu.tsx:52
msgid "팀 메뉴"
msgstr "Team menu"

#: apps/ui/src/features/team/TeamSettingsDialog.tsx:163
msgid "팀 삭제하기"
msgstr "Delete team"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:226
#: apps/ui/src/features/team/TeamDropdown.tsx:42
#: apps/ui/src/features/team/TeamDropdown.tsx:68
msgid "팀 선택"
msgstr "Select team"

#: apps/ui/src/features/team/TeamItemMenu.tsx:84
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:122
#: apps/ui/src/features/team/TeamSettingsSection.tsx:39
msgid "팀 설정"
msgstr "Team settings"

#: apps/ui/src/features/team/CreateTeamDialog.tsx:75
msgid "팀 아이콘 선택"
msgstr "Choose team icon"

#: apps/ui/src/features/team/CreateTeamDialog.tsx:106
#: apps/ui/src/features/team/CreateTeamDialog.tsx:107
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:128
#: apps/ui/src/features/team/TeamSettingsDialog.tsx:135
#: apps/ui/src/features/team/TeamSettingsSection.tsx:75
#: apps/ui/src/features/team/TeamSettingsSection.tsx:82
msgid "팀 이름"
msgstr "Team name"

#: apps/ui/src/features/team/CreateTeamDialog.tsx:66
msgid "팀 이름과 아이콘을 정해주세요."
msgstr "Choose a name and icon for your team."

#: apps/ui/src/features/onboarding/TeamNameField.tsx:21
msgid "팀 이름을 알려주세요"
msgstr "What's your team name?"

#: apps/ui/src/views/InviteAcceptView.tsx:104
msgid "팀 초대를 받았어요"
msgstr "You've received a team invitation"

#: apps/ui/src/views/NotificationsView.tsx:50
msgid "팀 합류"
msgstr "Joined team"

#: apps/ui/src/views/OnboardingView.tsx:96
#: apps/ui/src/views/OnboardingView.tsx:114
msgid "팀 회의 자료 준비하기"
msgstr "Prepare team meeting materials"

#: apps/ui/src/views/InviteAcceptView.tsx:172
msgid "팀에 초대됐어요"
msgstr "You've been invited to a team"

#: apps/app/src/controllers/team-members.tsx:30
msgid "팀원"
msgstr "Members"

#: apps/ui/src/features/team/InviteMemberDialog.tsx:47
msgid "팀원 초대"
msgstr "Invite members"

#: apps/ui/src/features/onboarding/ThemePreview.tsx:17
msgid "팀원 초대하기"
msgstr "Invite teammates"

#: apps/ui/src/views/OnboardingView.tsx:308
msgid "팀을 만들어주세요"
msgstr "Create your team"

#: apps/ui/src/components/TaskCreateComposer.tsx:673
msgid "팀을 먼저 설정해주세요"
msgstr "Set up a team first"

#: apps/app/src/layouts/dashboard/Service.ts:1196
msgid "팀을 삭제하지 못했어요"
msgstr "Couldn't delete the team"

#: apps/app/src/layouts/dashboard/Service.ts:1195
msgid "팀을 삭제했어요"
msgstr "Deleted the team"

#: apps/app/src/layouts/dashboard/Service.ts:361
msgid "팀을 즐겨찾기에 추가했어요"
msgstr "Added the team to favorites"

#: apps/app/src/layouts/dashboard/Service.ts:371
msgid "팀을 즐겨찾기에서 제거했어요"
msgstr "Removed the team from favorites"

#: apps/ui/src/components/TimezoneSelect.tsx:27
msgid "파리"
msgstr "Paris"

#: apps/ui/src/features/calendar/CalendarExportDialog.tsx:162
msgid "파일로 내보내기"
msgstr "Export to file"

#: apps/ui/src/components/AttachmentUploadDialog.tsx:192
msgid "파일을 끌어다 놓거나 <0>찾아보기</0>"
msgstr "Drag files here or <0>browse</0>"

#: apps/app/src/controllers/settings.tsx:392
msgid "팔레트"
msgstr "Palette"

#: apps/ui/src/components/TimezoneSelect.tsx:24
msgid "퍼스"
msgstr "Perth"

#: apps/app/src/controllers/task-view.tsx:134
#: apps/ui/src/atom/EditableAvatar.tsx:98
#: apps/ui/src/components/editor/LinkRichCard.tsx:75
msgid "편집"
msgstr "Edit"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:256
msgid "펼치기"
msgstr "Expand"

#: apps/ui/src/components/ThemeSelect.tsx:23
msgid "포레스트"
msgstr "Forest"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:238
msgid "폰트"
msgstr "Font"

#: apps/ui/src/features/team/FolderItemMenu.tsx:106
msgid "폴더 메뉴"
msgstr "Folder menu"

#: apps/ui/src/features/team/FolderItemMenu.tsx:152
msgid "폴더 삭제"
msgstr "Delete folder"

#: apps/ui/src/features/team/CreateFolderDialog.tsx:60
#: apps/ui/src/features/team/CreateFolderDialog.tsx:61
#: apps/ui/src/features/team/FolderItemMenu.tsx:63
#: apps/ui/src/features/team/FolderItemMenu.tsx:64
msgid "폴더 이름"
msgstr "Folder name"

#: apps/ui/src/features/team/FolderItemMenu.tsx:50
msgid "폴더 이름 바꾸기"
msgstr "Rename folder"

#: apps/ui/src/features/team/CreateFolderDialog.tsx:50
#: apps/ui/src/features/team/FolderItemMenu.tsx:53
msgid "폴더 이름을 입력해주세요."
msgstr "Enter a folder name."

#: apps/ui/src/components/TableBubbleMenu.tsx:93
msgid "표 삭제"
msgstr "Delete table"

#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:400
msgid "표시 텍스트 · 제거"
msgstr "Display text · Remove"

#: apps/ui/src/components/editor/EditorBubbleMenu.tsx:169
#: apps/ui/src/components/editor/LinkBubbleMenu.tsx:374
msgid "표시할 텍스트"
msgstr "Display text"

#: apps/app/src/controllers/settings.tsx:491
#: apps/app/src/controllers/settings.tsx:509
msgid "푸시 테스트"
msgstr "Test push"

#: apps/ui/src/features/task-view/TaskViewForm.tsx:252
#: apps/ui/src/features/task-view/TaskViewForm.tsx:256
msgid "프로젝트"
msgstr "Project"

#: apps/app/src/controllers/settings.tsx:330
msgid "프로필"
msgstr "Profile"

#: apps/ui/src/atom/EditableAvatar.tsx:108
msgid "프로필 사진 변경"
msgstr "Change profile photo"

#: apps/app/src/controllers/settings/ProfileModal.tsx:134
msgid "프로필 사진과 표시할 이름을 변경할 수 있어요."
msgstr "You can change your profile photo and display name."

#: apps/app/src/queries/User.ts:56
#: apps/app/src/queries/User.ts:61
msgid "프로필 사진을 저장하지 못했습니다."
msgstr "Couldn't save the profile photo."

#: apps/ui/src/features/task/TaskListFilter.tsx:86
#: apps/ui/src/features/task/TaskListFilter.tsx:95
#: apps/ui/src/features/task/TaskListFilter.tsx:106
msgid "필터"
msgstr "Filter"

#: apps/ui/src/features/task/TaskListEmpty.tsx:53
msgid "필터 초기화"
msgstr "Reset filters"

#: apps/ui/src/features/task/TaskListEmpty.tsx:45
msgid "필터를 바꾸면 다른 할일을 볼 수 있어요."
msgstr "Change your filters to see other tasks."

#: apps/ui/src/components/InstallPromptBanner.tsx:80
msgid "하단의 공유 버튼 <0/> 을 누르고 <1>홈 화면에 추가 <2/></1> 를 선택하세요."
msgstr "Tap the Share button <0/> below, then choose <1>Add to Home Screen <2/></1>."

#: apps/ui/src/components/ReminderDayComposer/QuickTimePresets.tsx:18
msgid "하루 뒤"
msgstr "In 1 day"

#: apps/ui/src/views/OneTaskView.tsx:979
#: apps/ui/src/views/PublicTaskView.tsx:197
msgid "하위 작업"
msgstr "Subtasks"

#: apps/ui/src/components/TaskRow.tsx:209
#: apps/ui/src/features/task/TaskBoard.tsx:598
msgid "하위 작업 {subtaskCount}개 중 {doneSubtaskCount}개 완료"
msgstr "{doneSubtaskCount} of {subtaskCount} subtasks done"

#: apps/ui/src/components/SubtaskList.tsx:137
msgid "하위 작업 추가"
msgstr "Add subtask"

#: apps/ui/src/views/OnboardingView.tsx:66
msgid "학생"
msgstr "Student"

#: apps/app/src/lib/NativeBackButton.ts:69
msgid "한 번 더 뒤로가기를 누르면 종료돼요"
msgstr "Press back again to exit"

#: apps/ui/src/components/ReminderDayComposer/RepeatModeToggle.tsx:12
#: apps/ui/src/components/ReminderList.tsx:37
msgid "한 번만"
msgstr "Once"

#: apps/ui/src/components/ReminderDayComposer/QuickTimePresets.tsx:14
msgid "한 시간 뒤"
msgstr "In 1 hr"

#: apps/ui/src/atom/TaskStatusIcon.tsx:52
msgid "할 일"
msgstr "Tasks"

#: apps/app/src/hooks/UseNotificationNudge.ts:42
msgid "할 일 알림을 받으려면 알림을 허용해 주세요."
msgstr "Allow notifications to receive task reminders."

#: apps/app/src/queries/all-tasks.ts:553
msgid "할 일 추가에 실패했어요. 다시 시도해 주세요."
msgstr "Failed to add the task. Please try again."

#: apps/app/src/layouts/dashboard/Service.ts:365
msgid "할 일을 즐겨찾기에 추가했어요"
msgstr "Added the task to favorites"

#: apps/app/src/layouts/dashboard/Service.ts:375
msgid "할 일을 즐겨찾기에서 제거했어요"
msgstr "Removed the task from favorites"

#: apps/app/src/layouts/dashboard/Service.ts:1083
msgid "할 일을 추가했어요"
msgstr "Added the task"

#: apps/ui/src/features/task/TaskListToolbarActions.tsx:71
msgid "할일 목록 메뉴"
msgstr "Task list menu"

#: apps/app/src/queries/ReminderNlp.ts:109
msgid "할일을 완성하지 못했어요."
msgstr "Couldn't complete the task."

#: apps/ui/src/components/ClearReminderConfirmDialog.tsx:56
#: apps/ui/src/components/CompleteReminderDialog.tsx:59
#: apps/ui/src/components/SessionList.tsx:125
#: apps/ui/src/features/auth/RevokeSessionDialog.tsx:55
msgid "해제"
msgstr "Turn off"

#: apps/ui/src/views/PublicLinkDialog.tsx:202
msgid "해제하면 이 링크로 더 이상 작업을 볼 수 없어요."
msgstr "Once disabled, this link can no longer be used to view the task."

#: apps/ui/src/components/TableBubbleMenu.tsx:55
msgid "행 삭제"
msgstr "Delete row"

#: apps/ui/src/components/TableBubbleMenu.tsx:87
msgid "헤더 행 토글"
msgstr "Toggle header row"

#: apps/ui/src/components/SessionList.tsx:108
msgid "현재 세션"
msgstr "Current session"

#: apps/app/src/controllers/settings/DevInfoModal.tsx:194
msgid "현재 세션·유저·기기 정보예요. 문제 리포트 시 참고해 주세요."
msgstr "Current session, user, and device info. Useful when reporting issues."

#: apps/ui/src/features/auth/RevokeOtherSessionsDialog.tsx:34
msgid "현재 세션을 제외한 다른 모든 기기에서 로그아웃돼요. 다시 이용하려면 각 기기에서 로그인이 필요해요."
msgstr "All devices except the current session will be signed out. You'll need to sign in again on each device."

#: apps/app/src/hooks/UseTimezoneNudge.ts:42
msgid "현재 위치는 {detected} 예요. 설정은 {userTimezone} 로 되어 있어요."
msgstr "Your current location is {detected}. Your setting is {userTimezone}."

#: apps/app/src/hooks/UseTimezoneNudge.ts:41
msgid "현재 위치의 시간대가 설정과 달라요"
msgstr "Your current location's time zone differs from your setting"

#: apps/ui/src/components/TimezoneSelect.tsx:43
msgid "호놀룰루"
msgstr "Honolulu"

#. placeholder {0}: testNotificationStatus.status
#: apps/app/src/controllers/settings.tsx:470
msgid "호출 성공 (status {0})."
msgstr "Call succeeded (status {0})."

#: apps/ui/src/components/TimezoneSelect.tsx:20
msgid "호치민"
msgstr "Ho Chi Minh City"

#: apps/ui/src/components/InstallPromptBanner.tsx:61
msgid "홈 화면에 추가하면 더 빠르고 알림도 받을 수 있어요."
msgstr "Add it to your home screen for faster access and notifications."

#: apps/ui/src/components/InstallPromptBanner.tsx:57
msgid "홈 화면에 추가하면 앱처럼 더 빠르게 열 수 있어요."
msgstr "Add it to your home screen to open it like an app."

#: apps/ui/src/components/TimezoneSelect.tsx:15
msgid "홍콩"
msgstr "Hong Kong"

#: apps/app/src/controllers/settings.tsx:380
msgid "화면"
msgstr "Screen"

#: apps/ui/src/views/OnboardingView.tsx:207
msgid "화면 밝기"
msgstr "Screen brightness"

#: apps/app/src/controllers/settings/DeleteAccountModal.tsx:104
msgid "확인"
msgstr "Confirm"

#: apps/app/src/controllers/settings/DeleteAccountModal.tsx:67
msgid "확인을 위해 현재 이메일 <0>{email}</0>을 입력하세요"
msgstr "Enter your current email <0>{email}</0> to confirm"

#: apps/ui/src/components/SessionList.tsx:145
msgid "활성 세션이 없어요."
msgstr "No active sessions."

#: apps/app/src/controllers/settings/DeleteAccountModal.tsx:58
msgid "회원님이 소유한 팀도 모두 함께 삭제돼요. 지금 로그아웃되고, 7일 이내에 다시 로그인하지 않으면 계정과 모든 데이터가 영구히 삭제됩니다."
msgstr "All teams you own will be deleted as well. You'll be logged out now, and if you don't log in again within 7 days, your account and all data will be permanently deleted."
